        // --- Synchronizace všech play pages podle aktuálních epizod ---
        try {
          const allPages = await pagesApi.getPages();
          const usedPlayIds = new Set((prepared.episodes||[]).map(e => String(e.playId||'')));
          // Aktualizuj nebo smaž play pages podle aktuálních epizod
          for (const page of (Array.isArray(allPages) ? allPages : [])) {
            if (!page.path || !page.path.startsWith('/play/')) continue;
            const playId = page.path.replace('/play/', '');
            const ep = (prepared.episodes||[]).find(e => String(e.playId) === String(playId));
            if (ep) {
              // Aktualizuj obsah stránky podle aktuální epizody
              let parsed = {};
              try { parsed = JSON.parse(page.content || '{}'); } catch {}
              const nextContent = JSON.stringify({
                ...parsed,
                popupId: String(popupId),
                showTitle: prepared.title || '',
                epTitle: ep.title || '',
                season: ep.season || null,
                index: ep.index || null,
                img: prepared.listThumb || prepared.searchPoster || prepared.heroImage || ep.thumb || '',
                contentType: prepared.contentType || '',
                vipOnly: !!ep.vipOnly
              });
              await pagesApi.addPage({ title: page.title, path: page.path, content: nextContent });
            } else {
              // Epizoda už neexistuje, stránku můžeš smazat nebo označit jako neplatnou (volitelné)
              // await pagesApi.removePage(page.id || page.path || page.slug);
            }
          }
        } catch (e) { /* ignore */ }
        // --- konec synchronizace play pages ---
import { useAuth } from '../contexts/AuthContext';
import * as contApi from '../api/continue';
import { RxDragHandleDots2 } from 'react-icons/rx';
  // Drag & drop epizod v rámci aktuální řady
  function useEpDragAndDrop(episodes, setEpisodes) {
    const [draggedIdx, setDraggedIdx] = useState(null);
    const [dragOverIdx, setDragOverIdx] = useState(null);
    const [dragging, setDragging] = useState(false);

    const handleMouseDown = (idx) => {
      setDraggedIdx(idx);
      setDragOverIdx(idx);
      setDragging(true);
      document.body.style.userSelect = 'none';
    };
    const handleMouseEnter = (idx) => {
      if (dragging && draggedIdx !== null && idx !== dragOverIdx) {
        setDragOverIdx(idx);
      }
    };
    const handleMouseUp = (idx) => {
      if (dragging && draggedIdx !== null && dragOverIdx !== null) {
        if (draggedIdx !== dragOverIdx) {
          const updated = episodes.slice();
          const [removed] = updated.splice(draggedIdx, 1);
          updated.splice(dragOverIdx, 0, removed);
          setEpisodes(updated);
        }
      }
      setDragging(false);
      setDraggedIdx(null);
      setDragOverIdx(null);
      document.body.style.userSelect = '';
    };
    React.useEffect(() => {
      if (!dragging) return;
      const onUp = () => {
        setDragging(false);
        setDraggedIdx(null);
        setDragOverIdx(null);
        document.body.style.userSelect = '';
      };
      window.addEventListener('mouseup', onUp);
      return () => window.removeEventListener('mouseup', onUp);
    }, [dragging]);
    return { draggedIdx, dragOverIdx, dragging, handleMouseDown, handleMouseEnter, handleMouseUp };
  }
import React, { useEffect, useMemo, useRef, useState } from 'react';
// Use ReactCountryFlag component to render flags (package already in dependencies)
import ReactCountryFlag from 'react-country-flag';
import { IoPlayCircleOutline, IoClose } from 'react-icons/io5';
import { LuVolume2, LuVolumeOff } from 'react-icons/lu';
import { useHistory, useLocation } from 'react-router-dom';
import * as mediaStore from '../api/mediaStore';
import * as customItemsStore from '../api/customItemsStore';
import * as pagesApi from '../api/pagesStore';
import { toEmbedAutoplay } from '../api/filemoon';
import * as tmdb from '../api/tmdb';
import { searchLogos } from '../api/googleImages';
import * as r2 from '../api/r2';
import { translateText } from '../api/translate';

const apiBase = process.env.REACT_APP_PAGES_API || '/api';

// Minimal language map kept for backwards-compatibility; flags are now country codes
const LANG_MAP = {
  cs: { code: 'cs', name: 'Čeština', country: 'cz' },
  en: { code: 'en', name: 'English', country: 'gb' },
  de: { code: 'de', name: 'Deutsch', country: 'de' },
  pl: { code: 'pl', name: 'Polski', country: 'pl' }
};

// Full searchable language list (code = ISO 639-1, name = native name, country = ISO3166 alpha-2 for flag)
const LANGUAGE_LIST = [
  { code: 'cs', name: 'Čeština', country: 'cz' },
  { code: 'sk', name: 'Slovenčina', country: 'sk' },
  { code: 'en', name: 'English', country: 'gb' },
  { code: 'de', name: 'Deutsch', country: 'de' },
  { code: 'pl', name: 'Polski', country: 'pl' },
  { code: 'fr', name: 'Français', country: 'fr' },
  { code: 'es', name: 'Español', country: 'es' },
  { code: 'it', name: 'Italiano', country: 'it' },
  { code: 'ru', name: 'Русский', country: 'ru' },
  { code: 'uk', name: 'Українська', country: 'ua' },
  { code: 'hu', name: 'Magyar', country: 'hu' },
  { code: 'ro', name: 'Română', country: 'ro' },
  { code: 'pt', name: 'Português', country: 'pt' },
  { code: 'nl', name: 'Nederlands', country: 'nl' },
  { code: 'sv', name: 'Svenska', country: 'se' },
  { code: 'no', name: 'Norsk', country: 'no' },
  { code: 'fi', name: 'Suomi', country: 'fi' },
  { code: 'da', name: 'Dansk', country: 'dk' },
  { code: 'tr', name: 'Türkçe', country: 'tr' },
  { code: 'zh', name: '中文', country: 'cn' },
  { code: 'ja', name: '日本語', country: 'jp' },
  { code: 'ko', name: '한국어', country: 'kr' },
  { code: 'ar', name: 'العربية', country: 'sa' },
  { code: 'he', name: 'עברית', country: 'il' },
  { code: 'el', name: 'Ελληνικά', country: 'gr' },
  { code: 'bg', name: 'Български', country: 'bg' },
  { code: 'sr', name: 'Српски', country: 'rs' },
  { code: 'hr', name: 'Hrvatski', country: 'hr' },
  { code: 'sl', name: 'Slovenščina', country: 'si' }
];

export default function AdminSeriesPopupEditor() {
  const { user } = useAuth ? useAuth() : { user: null };
  const empty = useMemo(() => ({
    title: 'Nový seriál',
    heroImage: '',
    seriesLogo: '',
    year: '',
    overview: '',
    runtimeMins: 0,
    genres: [], // array of strings
    seasons: 1,
    episodes: [], // {season,index,title,thumb,videoUrl,desc}
    watchlist: false,
    previewHasVideo: false,
    previewVideoUrl: '',
    contentType: '', // 'serial' | 'film' (required)
    lockContentType: false, // when true, lock radio selection even for new items
    listThumb: '',   // thumbnail for /serialy or /filmy grid
    searchPoster: '', // poster image for search results
    tmdbType: '',     // 'tv' | 'movie'
    tmdbId: null      // numeric TMDb id
  }), []);

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [model, setModel] = useState(empty);
  const [editingId, setEditingId] = useState(null);
  const [previewOpenState, setPreviewOpenState] = useState(false);
  const [error, setError] = useState('');
  const [selectedSeason, setSelectedSeason] = useState(1);
  const [previewSeasonsOpen, setPreviewSeasonsOpen] = useState(false);
  const [season0ConfirmOpen, setSeason0ConfirmOpen] = useState(false);
  const [deleteSeasonConfirmOpen, setDeleteSeasonConfirmOpen] = useState(false);
  const [seasonToDelete, setSeasonToDelete] = useState(null);
  const history = useHistory();
  const location = useLocation();
  const [copiedKey, setCopiedKey] = useState('');
  const [openEps, setOpenEps] = useState({}); // idx:boolean for collapsible episode editors
  const [previewVideoActive, setPreviewVideoActive] = useState(false);
  const [previewVideoMuted, setPreviewVideoMuted] = useState(false);
  const previewVideoRef = useRef(null);
  const [tmdbOpen, setTmdbOpen] = useState(false);
  const [tmdbQuery, setTmdbQuery] = useState('');
  const [tmdbResults, setTmdbResults] = useState([]);
  const [tmdbBusy, setTmdbBusy] = useState(false);
  const [tmdbError, setTmdbError] = useState('');
  const [tmdbMode, setTmdbMode] = useState('tv');
  const [fmOpen, setFmOpen] = useState(false);
  const [fmForEpIndex, setFmForEpIndex] = useState(null);
  const [fmLangForEp, setFmLangForEp] = useState(null); // { idx, code }
  const [fmQuery, setFmQuery] = useState('');
  const [fmBusy, setFmBusy] = useState(false);
  const [fmError, setFmError] = useState('');
  const [fmResults, setFmResults] = useState([]);
  const [fmTab, setFmTab] = useState('search'); // 'search' | 'folders'
  const [fmFolders, setFmFolders] = useState([]);
  const [fmFolderId, setFmFolderId] = useState('');
  const [fmFolderFiles, setFmFolderFiles] = useState([]);
  const fmFolderSearchRef = useRef(null);
  const [fmFoldersSort, setFmFoldersSort] = useState('name:asc'); // 'name:asc' | 'name:desc'
  const [fmFilesSort, setFmFilesSort] = useState('name:asc'); // 'name:asc' | 'name:desc'
  const fmFoldersSortRef = useRef(null);
  const fmFilesSortRef = useRef(null);

  function openNativeSelect(ref) {
    try {
      const el = ref && ref.current;
      if (!el) return;
      if (typeof el.showPicker === 'function') {
        // modern Chrome/Edge
        el.showPicker();
        return;
      }
      // fallback: focus and dispatch mousedown to attempt open
      el.focus();
      const ev = new MouseEvent('mousedown', { bubbles: true, cancelable: true });
      el.dispatchEvent(ev);
    } catch (e) {
      // ignore
    }
  }

  // TMDb image picker (posters/backdrops)
  const [imgPickerOpen, setImgPickerOpen] = useState(false);
  const [imgPickerKind, setImgPickerKind] = useState('thumb'); // 'thumb' | 'poster' | 'hero' | 'logo' | 'ep'
  const [imgPickerBusy, setImgPickerBusy] = useState(false);
  const [imgPickerError, setImgPickerError] = useState('');
  const [googleOpen, setGoogleOpen] = useState(false);
  const [googleBusy, setGoogleBusy] = useState(false);
  const [googleError, setGoogleError] = useState('');
  const [googleResults, setGoogleResults] = useState([]);
  const [r2Open, setR2Open] = useState(false);
  const [r2Busy, setR2Busy] = useState(false);
  const [r2Error, setR2Error] = useState('');
  const [r2Items, setR2Items] = useState([]);
  const [imgPickerItems, setImgPickerItems] = useState([]); // {url, w, h}
  const [imgPickerEp, setImgPickerEp] = useState({ season: null, index: null, idx: null });
  // Add-language modal state
  const [addLangModalOpen, setAddLangModalOpen] = useState(false);
  const [addLangEpIdx, setAddLangEpIdx] = useState(null);
  const [addLangQuery, setAddLangQuery] = useState('');
  const addLangInputRef = useRef(null);

  // focus the add-language search input shortly after modal opens
  useEffect(() => {
    if (!addLangModalOpen) return;
    const t = setTimeout(() => {
      try { addLangInputRef.current && addLangInputRef.current.focus(); } catch (e) {}
    }, 40);
    return () => clearTimeout(t);
  }, [addLangModalOpen]);
  const [langRemoveConfirmOpen, setLangRemoveConfirmOpen] = useState(false);
  const [langRemoveTarget, setLangRemoveTarget] = useState(null); // { idx, code }

  async function openImagePicker(kind, opts = {}) {
    setImgPickerKind(kind);
    setImgPickerOpen(true);
    setImgPickerError('');
    setImgPickerItems([]);
    if (kind==='ep') setImgPickerEp({ season: opts.season||null, index: opts.index||null, idx: opts.idx||null });
    let tvId = model.tmdbType==='tv' ? model.tmdbId : null;
    let movieId = model.tmdbType==='movie' ? model.tmdbId : null;
    // Fallback: if no ids, try search by title to resolve id quickly
    if (!tvId && !movieId) {
      try {
        const q = (model.title||'').trim();
        if (q) {
          if (model.contentType==='film') {
            const r = await tmdb.searchMovie(q, { language:'cs-CZ' }).catch(()=>[]);
            movieId = r?.[0]?.id || null;
          } else {
            const r = await tmdb.searchTV(q, { language:'cs-CZ' }).catch(()=>[]);
            tvId = r?.[0]?.id || null;
          }
        }
      } catch {}
    }
    if (!tvId && !movieId) { setImgPickerError('Nenalezeno TMDb ID (zkus importovat nebo upravit název).'); return; }
    try {
      setImgPickerBusy(true);
      if (kind==='ep') {
        const { season, index } = opts || {};
        if (!tvId || !season || !index) { setImgPickerError('Chybí číslo řady/dílu nebo TV ID.'); }
        else {
          const imgs = await tmdb.getEpisodeImages(tvId, season, index).catch(()=>null);
          const stills = Array.isArray(imgs?.stills) ? imgs.stills : [];
          setImgPickerItems(stills.map(it => ({ url: tmdb.buildImageUrl(it.file_path, 'w500'), w: it.width, h: it.height })));
        }
      } else {
        let data = null;
        if (tvId) data = await tmdb.getTVImages(tvId);
        if (!data && movieId) data = await tmdb.getMovieImages(movieId);
        const posters = Array.isArray(data?.posters) ? data.posters : [];
        const backdrops = Array.isArray(data?.backdrops) ? data.backdrops : [];
        if (kind==='poster') {
          setImgPickerItems(posters.map(it => ({ url: tmdb.buildImageUrl(it.file_path, 'w500'), w: it.width, h: it.height })));
        } else {
          // thumb/hero/logo: use backdrops as base
          setImgPickerItems(backdrops.map(it => ({ url: tmdb.buildImageUrl(it.file_path, 'w780'), w: it.width, h: it.height })));
        }
      }
    } catch (e) {
      console.error('tmdb images error', e);
      setImgPickerError('Nelze načíst obrázky z TMDb.');
    } finally {
      setImgPickerBusy(false);
    }
  }

  // Saved popups browser: search + pagination + full collection modal
  const [savedSearch, setSavedSearch] = useState('');
  const [savedPage, setSavedPage] = useState(1);
  const perPage = 4; // max 4 popups per page
  const savedSearchInputRef = useRef(null);
  const [collectionOpen, setCollectionOpen] = useState(false);
  const [collectionQuery, setCollectionQuery] = useState('');
  const collectionInputRef = useRef(null);

  function autoGrow(el) {
    if (!el) return;
    try {
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
      el.style.overflow = 'hidden';
    } catch {}
  }

  function hashCode(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) {
      h = (h << 5) - h + str.charCodeAt(i);
      h |= 0;
    }
    return h;
  }

  function genPlayId() {
    // 9-digit random numeric id
    const n = Math.floor(100000000 + Math.random() * 900000000);
    return String(n);
  }

  async function ensurePlayPagesAndNormalize(data) {
    const m = { ...data, episodes: [...(data.episodes || [])] };
    for (let i = 0; i < m.episodes.length; i++) {
      const ep = m.episodes[i] || {};
      const hasUrl = (ep.videoUrl || '').trim().length > 0;
      if (!hasUrl) continue;
      const normalized = toEmbedAutoplay(ep.videoUrl);
      // always keep normalized URL
      ep.videoUrl = normalized;
      // normalize any language-specific video URLs as well
      try {
        if (Array.isArray(ep.languages)) {
          ep.languages = ep.languages.map(l => ({
            ...(l || {}),
            videoUrl: l && l.videoUrl ? toEmbedAutoplay(l.videoUrl) : (l && l.videoUrl) || ''
          }));
        }
      } catch (e) {}
      if (!ep.playId) {
        try {
          // record previous playId (if any) for remap detection
          if (ep.playId) ep._oldPlayId = ep.playId;
          const id = genPlayId();
          const path = `/play/${id}`;
          const title = `${m.title || 'Přehrát'} — S${ep.season || 1}E${ep.index || (i+1)}`;
            await pagesApi.addPage({ path, title, content: JSON.stringify({ url: normalized, popupId: String(editingId||''), showTitle: m.title || 'Přehrát', epTitle: ep.title || `S${ep.season || 1}E${ep.index || (i+1)}`, season: ep.season || 1, index: ep.index || (i+1), img: m.listThumb || m.searchPoster || m.heroImage || ep.thumb || '', vipOnly: !!ep.vipOnly }) });
          ep.playId = id;
        } catch (e) {
          console.warn('ensurePlayPagesAndNormalize: addPage failed', e);
        }
      }
      m.episodes[i] = ep;
    }
    return m;
  }

  // URL-driven preview: /admin/popups?preview=<id>|draft
  const search = location.search || '';
  const params = useMemo(() => new URLSearchParams(search), [search]);
  const previewParam = params.get('preview');
  const previewOpen = !!previewParam; // derived open flag
  const previewItem = useMemo(() => {
    if (!previewParam) return null;
    if (previewParam === 'draft') return { ...model };
    // If we're editing the same item as preview param, show in-memory model (unsaved changes)
    if (editingId && String(editingId) === String(previewParam)) return { ...model };
    const found = (list||[]).find(p => String(p.id) === String(previewParam));
    return found || null;
  }, [previewParam, model, list]);

  // Keep page layout stable: no body scroll locking to avoid layout shift. We'll rely on overlay overscroll containment.

  // Schedule preview video fade-in after open
  useEffect(() => {
    let t;
    // reset state on item change or close
    setPreviewVideoActive(false);
    setPreviewVideoMuted(false);
    if (previewOpen && previewItem && previewItem.previewHasVideo && previewItem.previewVideoUrl) {
      t = setTimeout(() => {
        setPreviewVideoActive(true);
      }, 2000);
    }
    return () => {
      if (t) clearTimeout(t);
      try {
        if (previewVideoRef.current) {
          previewVideoRef.current.pause();
        }
      } catch {}
    };
  }, [previewOpen, previewItem]);

  // When video becomes active, attempt autoplay with sound; fallback to muted if blocked
  useEffect(() => {
    if (!previewVideoActive) return;
    const v = previewVideoRef.current;
    if (!v) return;
    v.muted = false;
    const tryPlay = () => v.play().catch(() => {
      // Autoplay with sound blocked; mute and retry
      v.muted = true;
      setPreviewVideoMuted(true);
      return v.play().catch(() => {});
    });
    tryPlay();
  }, [previewVideoActive]);

  useEffect(() => { loadList(); }, []);
  useEffect(() => {
    // keep selected season in bounds
    setSelectedSeason(s => {
      const max = Math.max(1, Number(model.seasons) || 1);
      if (s < 1) return 1;
      if (s > max) return max;
      return s;
    });
  }, [model.seasons]);

  async function loadList() {
    setLoading(true);
    setError('');
    try {
      const r = await fetch(`${apiBase}/popups`, { cache: 'no-store' });
      const j = await r.json();
      setList(Array.isArray(j) ? j : []);
      setSavedPage(1);
    } catch (e) {
      console.error(e);
      setError('Nelze načíst popups');
    } finally { setLoading(false); }
  }

  async function doFilemoonSearch() {
    setFmError('');
    setFmResults([]);
    if (!fmQuery.trim()) return;
    try {
      setFmBusy(true);
      // Try public search first
      let all = [];
      try {
        const r = await fetch(`${apiBase}/filemoon/search?q=${encodeURIComponent(fmQuery.trim())}`);
        if (r.ok) {
          const j = await r.json();
          if (Array.isArray(j)) all = j;
        }
      } catch (_) {}
      // If nothing, try official account files API (requires server key)
      if (!all.length) {
        try {
          const r2 = await fetch(`${apiBase}/filemoon/my-files?search=${encodeURIComponent(fmQuery.trim())}`);
          if (r2.ok) {
            const j2 = await r2.json();
            if (Array.isArray(j2)) all = j2;
          }
        } catch (_) {}
      }
      setFmResults(all);
      if (!all.length) setFmError('Nic nenalezeno.');
    } catch (e) {
      console.error('filemoon search error', e);
      setFmError('Chyba vyhledávání Filemoon.');
    } finally {
      setFmBusy(false);
    }
  }

  function setField(k, v) { setModel(m => ({ ...m, [k]: v })); }

  function addSeason() {
    setModel(m => ({ ...m, seasons: Math.max(1, Number(m.seasons) || 1) + 1 }));
    setSelectedSeason(s => s + 1);
  }

  // Right-click handler: add a new season 0 before season 1.
  // If season 0 already exists, do nothing.
  function handleAddSeasonContext(e) {
    try {
      e && e.preventDefault && e.preventDefault();
      e && e.stopPropagation && e.stopPropagation();
      const has0 = (model && (model.hasSeason0 || (Array.isArray(model.episodes) && model.episodes.some(ep => (ep.season || 1) === 0))));
      if (has0) return; // disable right-click add when 0 already present
      // open a styled confirmation modal instead of native confirm
      setSeason0ConfirmOpen(true);
    } catch (err) {
      // ignore
    }
  }

  function confirmAddSeason0() {
    try {
      setModel(m => ({ ...m, hasSeason0: true }));
      setSelectedSeason(0);
    } catch (e) {}
    setSeason0ConfirmOpen(false);
  }
  function addEpisode(season) {
    const targetSeason = season || selectedSeason || 1;
    setModel(m => {
      const idxNew = (m.episodes?.length||0);
      const next = { ...m, episodes: [...(m.episodes||[]), { season: targetSeason, index: idxNew + 1, title: 'Nová epizoda', thumb: '', videoUrl: '', desc: '' }] };
      setOpenEps(prev => ({ ...prev, [idxNew]: true }));
      return next;
    });
  }
  function updEp(i, patch) {
    setModel(m => {
      const base = Array.isArray(m.episodes) ? m.episodes : [];
      const eps = [...base];
      const prev = eps[i] || {};
      eps[i] = { ...prev, ...patch };
      return { ...m, episodes: eps };
    });
  }
  async function updEpWithSideEffects(i, patch) {
    const before = model.episodes?.[i] || {};
    const rawNextUrl = patch.videoUrl !== undefined ? patch.videoUrl : before.videoUrl;
    const nextUrl = toEmbedAutoplay(rawNextUrl || '');
    // ensure we store normalized URL
    const toApply = { ...patch };
    if (patch.videoUrl !== undefined) toApply.videoUrl = nextUrl;
    updEp(i, toApply);
    // if videoUrl present, auto-create/update /play/:id page
    try {
      const ep = { ...(model.episodes?.[i] || {}), ...patch };
      const hasUrl = (nextUrl || '').trim().length > 0;
  if (hasUrl) {
        // remove previous play page if exists (to avoid orphan)
        if (ep.playId) {
          try {
            const pages = await pagesApi.getPages();
            const oldPath = `/play/${ep.playId}`;
            const prevPage = (Array.isArray(pages) ? pages : []).find(p => p.path === oldPath);
            if (prevPage) await pagesApi.removePage(prevPage.id || prevPage.path || prevPage.slug);
          } catch (_) {}
        }
        // generate random numeric id for play page
        // remember old playId (if any) so we can compute remaps later
        if (ep.playId) ep._oldPlayId = ep.playId;
        const id = genPlayId();
        const path = `/play/${id}`;
        const title = `${model.title || 'Přehrát'} — S${ep.season || 1}E${ep.index || (i+1)}`;
  await pagesApi.addPage({ path, title, content: JSON.stringify({ url: nextUrl, popupId: String(editingId||''), showTitle: model.title || 'Přehrát', epTitle: ep.title || `S${ep.season || 1}E${ep.index || (i+1)}`, season: ep.season || 1, index: ep.index || (i+1), img: model.listThumb || model.searchPoster || model.heroImage || ep.thumb || '', vipOnly: !!ep.vipOnly }) });
        // persist playId into episode for routing
        updEp(i, { playId: id });
      }
    } catch (e) {
      console.warn('Auto-create play page failed', e);
    }
  }

  // add language to episode i (or replace existing for same code)
  function addOrUpdateLangToEp(i, langCode, langObj) {
    // build next model synchronously and persist immediately
    try {
      const prev = model || {};
      const eps = Array.isArray(prev.episodes) ? prev.episodes.map(e => ({ ...(e||{}) })) : [];
      const prevEp = eps[i] || {};
      const langs = Array.isArray(prevEp.languages) ? [...prevEp.languages] : [];
      const existingIdx = langs.findIndex(x => x && x.code === langCode);

      // Determine candidate video URL from various possible properties
      const rawUrl = (langObj && (langObj.videoUrl || langObj.url || langObj.embedUrl || langObj.pageUrl)) || '';
      const normalizedUrl = rawUrl ? toEmbedAutoplay(rawUrl) : ((langObj && langObj.videoUrl) || '');

      // Preserve existing language entry fields when updating
      const existing = existingIdx >= 0 ? (langs[existingIdx] || {}) : null;
      const nextLang = {
        code: langCode,
        name: (langObj && (langObj.name || existing?.name)) || existing?.name || LANG_MAP[langCode]?.name || '',
  flag: (langObj && (langObj.flag || langObj.country || existing?.flag || existing?.country)) || existing?.flag || existing?.country || LANG_MAP[langCode]?.country || '',
        videoUrl: normalizedUrl || (existing && existing.videoUrl) || ''
      };

      if (existingIdx >= 0) langs[existingIdx] = nextLang; else langs.push(nextLang);
      const nextEp = { ...prevEp, languages: langs };
      eps[i] = nextEp;
      const nextModel = { ...prev, episodes: eps };
      setModel(nextModel);
      // persist immediately if editing existing popup
      quickSavePopupForModel(nextModel).then(()=>{}).catch(()=>{});
    } catch (e) { console.warn('addOrUpdateLangToEp failed', e); }
  }

  function removeLangFromEp(i, langCode) {
    try {
      const prev = model || {};
      const eps = Array.isArray(prev.episodes) ? prev.episodes.map(e => ({ ...(e||{}) })) : [];
      const prevEp = eps[i] || {};
      const langs = Array.isArray(prevEp.languages) ? prevEp.languages.filter(l => l && l.code !== langCode) : [];
      const nextEp = { ...prevEp, languages: langs };
      eps[i] = nextEp;
      const nextModel = { ...prev, episodes: eps };
      setModel(nextModel);
      quickSavePopupForModel(nextModel).then(()=>{}).catch(()=>{});
    } catch (e) { console.warn('removeLangFromEp failed', e); }
  }

  // Quick-save helper: persist popup immediately when editing an existing popup
  async function quickSavePopupForModel(nextModel) {
    try {
      if (!editingId) return; // only save when editing an existing popup
      const prepared = await ensurePlayPagesAndNormalize(nextModel || model || {});
      // PUT to update the popup on server
      await fetch(`${apiBase}/popups/${encodeURIComponent(editingId)}`, { method: 'PUT', headers: { 'content-type':'application/json' }, body: JSON.stringify(prepared) });
      // refresh list and notify other windows
      try { await loadList(); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent('popup:changed', { detail: { popupId: String(editingId) } })); } catch (_) {}
    } catch (e) {
      console.warn('quickSavePopupForModel failed', e);
    }
  }

  // Set a language entry as the episode default video (replace ep.videoUrl)
  async function setLangAsDefault(i, langCode) {
    try {
      const ep = (model.episodes || [])[i] || null;
      if (!ep) return;
      const lang = Array.isArray(ep.languages) ? ep.languages.find(l => l && l.code === langCode) : null;
      if (!lang || !lang.videoUrl) {
        showToast('Vybraný jazyk nemá přiřazené video', 'error');
        return;
      }
      const normalized = toEmbedAutoplay(lang.videoUrl || '');
      // update episode videoUrl in the editor state
      updEp(i, { videoUrl: normalized });
      showToast('Výchozí video změněno', 'success');
      // If episode already has a playId, update the corresponding /play/:id page content
      const playId = ep.playId;
      if (playId) {
        try {
          const path = `/play/${playId}`;
          const title = `${model.title || 'Přehrát'} — S${ep.season || 1}E${ep.index || (i+1)}`;
          const content = JSON.stringify({ url: normalized, popupId: String(editingId||''), showTitle: model.title || 'Přehrát', epTitle: ep.title || `S${ep.season || 1}E${ep.index || (i+1)}`, season: ep.season || 1, index: ep.index || (i+1), img: model.listThumb || model.searchPoster || model.heroImage || ep.thumb || '', vipOnly: !!ep.vipOnly });
          await pagesApi.addPage({ path, title, content });
        } catch (e) {
          console.warn('Failed to update play page for language default', e);
        }
      }
    } catch (e) {
      console.error('setLangAsDefault error', e);
      showToast('Nelze nastavit výchozí video', 'error');
    }
  }
  function delEp(i) {
    const eps = [...model.episodes];
    eps.splice(i,1);
    setModel(m => ({ ...m, episodes: eps }));
    // Re-map openEps to shifted indices
    setOpenEps(prev => {
      const next = {};
      Object.keys(prev).forEach(k => {
        const ki = Number(k);
        if (ki === i) return;
        const newIndex = ki > i ? ki - 1 : ki;
        next[newIndex] = prev[ki];
      });
      return next;
    });
  }

  function deleteSeason(seasonNumber) {
    // Open styled confirmation modal first
    setSeasonToDelete(seasonNumber);
    setDeleteSeasonConfirmOpen(true);
  }

  function performDeleteSeason() {
    const seasonNumber = seasonToDelete;
    if (seasonNumber === null || seasonNumber === undefined) {
      setDeleteSeasonConfirmOpen(false);
      setSeasonToDelete(null);
      return;
    }
    // Special-case deleting season 0: just remove the flag (no shifting)
    if (seasonNumber === 0) {
      setModel(m => ({ ...m, hasSeason0: undefined }));
      setSelectedSeason(s => Math.max(1, Number(s) || 1));
      setOpenEps({});
      setDeleteSeasonConfirmOpen(false);
      setSeasonToDelete(null);
      return;
    }
    const total = Math.max(0, Number(model.seasons)||0);
    const visibleCount = total + (model && model.hasSeason0 ? 1 : 0);
    if (visibleCount <= 1) {
      // nothing to delete (would leave zero seasons)
      setDeleteSeasonConfirmOpen(false);
      setSeasonToDelete(null);
      return;
    }
    const newEpisodes = (model.episodes||[])
      .filter(ep => (ep.season||1) !== seasonNumber)
      .map(ep => (ep.season||1) > seasonNumber ? { ...ep, season: (ep.season||1) - 1 } : ep);
    setModel(m => ({ ...m, seasons: total - 1, episodes: newEpisodes }));
    setSelectedSeason(s => Math.min(s, total - 1));
    setOpenEps({});
    setDeleteSeasonConfirmOpen(false);
    setSeasonToDelete(null);
  }

  async function save() {
    try {
      // Convert Filemoon URLs to /play pages and attach playId before saving
      const prepared = await ensurePlayPagesAndNormalize(model);
      setModel(prepared);
      const wasEdit = !!editingId;
      const method = wasEdit ? 'PUT' : 'POST';
      const url = wasEdit ? `${apiBase}/popups/${editingId}` : `${apiBase}/popups`;
      if (!model.contentType) { showToast('Vyber typ: Seriál nebo Film', 'error'); return; }
      const r = await fetch(url, { method, headers: { 'content-type':'application/json' }, body: JSON.stringify(prepared) });
      if (!r.ok) throw new Error('save failed');
      let resp = null;
      try { resp = await r.json(); } catch(_) {}

      // determine popupId after save
      let popupId = null;
      if (wasEdit && editingId) popupId = String(editingId);
      if (!popupId) {
        if (resp && typeof resp === 'object') {
          if (Array.isArray(resp)) {
            const latest = resp[0] || resp.find?.(x=>x && x.id) || null;
            if (latest && latest.id != null) popupId = String(latest.id);
          } else if (resp.id != null) {
            popupId = String(resp.id);
          }
        }
      }

      await loadList();

      // Fallback: find in list by title if id not found
      if (!popupId && prepared && prepared.title) {
        const found = (list||[]).find(p => p.title === prepared.title);
        if (found && found.id != null) popupId = String(found.id);
      }

      // Sync to Serialy/Filmy and Search
      if (popupId) {
        await syncCatalogAndSearch(popupId, prepared);
        // Cleanup orphan /play pages that belonged to this popup but are no longer referenced
        try {
          await cleanupOrphanPlayPages(popupId, prepared);
        } catch (e) { console.warn('cleanupOrphanPlayPages failed', e); }

        // --- OPRAVA: Projdi všechny záznamy continueSeries pro tento popupId a aktualizuj nebo smaž podle aktuálních epizod ---
        if (user) {
          try {
            const contList = await contApi.listSeries(user.uid, 200);
            const conts = (contList||[]).filter(c => String(c.popupId) === String(popupId));
            const eps = Array.isArray(prepared.episodes) ? prepared.episodes : [];
            // build remap table of oldPlayId -> newPlayId for server-side propagation
            const remaps = {};
            for (const ep of eps) {
              if (ep && ep.playId && ep._oldPlayId && String(ep._oldPlayId) !== String(ep.playId)) {
                remaps[String(ep._oldPlayId)] = String(ep.playId);
              }
            }
            for (const cont of conts) {
              if (!cont.playId) continue;
              // 1) Try exact match by playId
              let ep = eps.find(e => String(e.playId) === String(cont.playId));
              if (!ep) {
                // 2) Try match by season+index
                ep = eps.find(e => (e.season || null) === (cont.season || null) && (e.index || null) === (cont.index || null));
              }
              if (!ep) {
                // 3) Try exact title match (trimmed)
                const t = (cont.epTitle || '').trim();
                if (t) ep = eps.find(e => (e.title || '').trim() === t);
              }
              if (!ep) {
                // 4) Try match by index only (best-effort)
                if (cont.index != null) ep = eps.find(e => (e.index || null) === (cont.index || null));
              }

              if (!ep) {
                // No matching episode found -> remove the continueSeries entry for this popup
                try { await contApi.removeSeries(user.uid, String(popupId)); } catch (_) {}
                continue;
              }

              // If found (either same playId or remapped), ensure continueSeries points to the correct playId and metadata
              const needsUpdate = (
                String(ep.playId) !== String(cont.playId) ||
                ep.season !== cont.season ||
                ep.index !== cont.index ||
                (ep.title || '') !== (cont.epTitle || '') ||
                (ep.thumb || '') !== (cont.img || '') ||
                `/play/${ep.playId}` !== (cont.path || '')
              );
              if (needsUpdate) {
                try {
                  await contApi.upsertSeries(user.uid, String(popupId), {
                    ...cont,
                    playId: ep.playId,
                    path: `/play/${ep.playId}`,
                    epTitle: ep.title || cont.epTitle || '',
                    season: ep.season || null,
                    index: ep.index || null,
                    img: ep.thumb || cont.img || ''
                  });
                } catch (_) {}
              }
            }
            // If we built remaps, POST them to server so other clients can fetch and apply
            if (Object.keys(remaps).length) {
              try {
                await fetch(`${apiBase}/popups/${encodeURIComponent(popupId)}/remaps`, {
                  method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ remaps })
                });
                try { window.dispatchEvent(new CustomEvent('popup:remapped', { detail: { id: String(popupId), remaps } })); } catch (_) {}
              } catch (_) {}
            }
          } catch (e) { /* ignore */ }
        }
        // --- konec opravy ---
      }

      setEditingId(null);
      setModel(empty);
      showToast(wasEdit ? 'Změny uloženy' : 'Popup přidán', wasEdit ? 'warning' : 'success');
    } catch (e) { console.error(e); showToast('Chyba ukládání', 'error'); }
  }

  async function cleanupOrphanPlayPages(popupId, data) {
    // collect referenced playIds from data
    const used = new Set((data.episodes || []).map(ep => String(ep.playId || '')).filter(Boolean));
    // fetch all pages and remove ones that have meta.popupId==popupId but not in used
    try {
      const pages = await pagesApi.getPages();
      const toRemove = (Array.isArray(pages) ? pages : []).filter(p => {
        try {
          const parsed = JSON.parse(p.content || '{}');
          const pid = parsed && parsed.popupId ? String(parsed.popupId) : '';
          const playIdFromPath = (p.path || '').startsWith('/play/') ? (p.path || '').slice(6) : '';
          return pid === String(popupId) && playIdFromPath && !used.has(playIdFromPath);
        } catch { return false; }
      });
      for (const p of toRemove) {
        try { await pagesApi.removePage(p.id || p.path || p.slug); } catch (_) {}
      }
    } catch (e) {
      console.warn('cleanupOrphanPlayPages error', e);
    }
  }

  function edit(it) { setEditingId(it.id); setModel({ ...empty, ...it }); setSelectedSeason(1); }
  async function remove(id) {
    if (!window.confirm('Smazat popup?')) return;
  await fetch(`${apiBase}/popups/${id}`, { method:'DELETE', cache: 'no-store' });
    try { await fetch(`${apiBase}/popups/${encodeURIComponent(id)}/purged`, { method: 'POST' }); } catch {}
    try { window.dispatchEvent(new CustomEvent('popup:deleted', { detail: { id: String(id) } })); } catch {}
    await loadList();
    showToast('Popup odstraněn', 'error');
    try {
      await removeFromCatalogAndSearch(String(id));
      // Also remove any related /play pages
      try { await cleanupOrphanPlayPages(String(id), { episodes: [] }); } catch (_) {}
    } catch (e) { console.warn('catalog/search remove failed', e); }
  }

  async function copyLink(idOrDraft) {
    try {
      const param = idOrDraft ? String(idOrDraft) : (editingId ? String(editingId) : 'draft');
  const url = `?preview=${encodeURIComponent(param)}`;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const ta = document.createElement('textarea');
        ta.value = url; ta.style.position = 'fixed'; ta.style.left = '-9999px';
        document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta);
      }
      setCopiedKey(param);
      setTimeout(() => setCopiedKey(''), 1500);
    } catch (e) {
      console.error('copy failed', e);
      alert('Nepodařilo se zkopírovat odkaz');
    }
  }

  // Sync to /serialy or /filmy lists and to Search items
  async function syncCatalogAndSearch(popupId, data) {
    try {
      const kind = data.contentType === 'film' ? 'film' : 'serial';
      const link = kind === 'film'
        ? `/filmy?preview=${encodeURIComponent(String(popupId))}`
        : `/serialy?preview=${encodeURIComponent(String(popupId))}`;

      // First remove stale entries for this popupId from both lists and search (if user changed type)
      try {
        const sLink = `/serialy?preview=${encodeURIComponent(String(popupId))}`;
        const fLink = `/filmy?preview=${encodeURIComponent(String(popupId))}`;
        const arrS = await mediaStore.getItems('serial');
        const idxS = Array.isArray(arrS) ? arrS.findIndex(it => (it?.link || '') === sLink) : -1;
        if (idxS >= 0) await mediaStore.removeItem('serial', idxS);
        const arrF = await mediaStore.getItems('film');
        const idxF = Array.isArray(arrF) ? arrF.findIndex(it => (it?.link || '') === fLink) : -1;
        if (idxF >= 0) await mediaStore.removeItem('film', idxF);
        const items = await customItemsStore.getItems();
        const next = (items || []).filter(x => (x?.url || '') !== sLink && (x?.url || '') !== fLink);
        await customItemsStore.saveItems(next);
      } catch (_) {}

      // media catalog tile
      const mediaPayload = {
        title: data.title || 'Bez názvu',
        img: data.listThumb || data.heroImage || '',
        link
      };
      try {
        const arr = await mediaStore.getItems(kind);
        const idx = Array.isArray(arr) ? arr.findIndex(it => (it?.link || '') === link) : -1;
        if (idx >= 0) await mediaStore.updateItem(kind, idx, mediaPayload);
        else await mediaStore.addItem(kind, mediaPayload);
      } catch (err) {
        console.warn('mediaStore sync failed', err);
      }

      // search item
      try {
        const entry = {
          title: data.title || 'Bez názvu',
          url: link,
          img: data.searchPoster || data.listThumb || data.heroImage || '',
          type: kind
        };
        const items = await customItemsStore.getItems();
        const i = Array.isArray(items) ? items.findIndex(x => (x?.url || '') === link) : -1;
        if (i >= 0) {
          const next = [...items];
          next[i] = entry;
          await customItemsStore.saveItems(next);
        } else {
          await customItemsStore.addItem(entry);
        }
      } catch (err) {
        console.warn('search sync failed', err);
      }

      // notify UI to refresh catalog/search views
      try { window.dispatchEvent(new CustomEvent('catalog:changed', { detail: { popupId: String(popupId), type: kind, payload: mediaPayload } })); } catch {}
      try { window.dispatchEvent(new CustomEvent('search:changed', { detail: { popupId: String(popupId) } })); } catch {}

    } catch (e) {
      console.warn('syncCatalogAndSearch error', e);
    }
  }

  async function removeFromCatalogAndSearch(popupId) {
    const serialLink = `/serialy?preview=${encodeURIComponent(String(popupId))}`;
    const filmLink = `/filmy?preview=${encodeURIComponent(String(popupId))}`;
    try {
      // mediaStore serial
      try {
        const arrS = await mediaStore.getItems('serial');
        const idxS = Array.isArray(arrS) ? arrS.findIndex(it => (it?.link || '') === serialLink) : -1;
        if (idxS >= 0) await mediaStore.removeItem('serial', idxS);
      } catch (err) { /* ignore */ }
      // mediaStore film
      try {
        const arrF = await mediaStore.getItems('film');
        const idxF = Array.isArray(arrF) ? arrF.findIndex(it => (it?.link || '') === filmLink) : -1;
        if (idxF >= 0) await mediaStore.removeItem('film', idxF);
      } catch (err) { /* ignore */ }

      // search items
      try {
        const items = await customItemsStore.getItems();
        const next = (items || []).filter(x => (x?.url || '') !== serialLink && (x?.url || '') !== filmLink);
        await customItemsStore.saveItems(next);
      } catch (err) { /* ignore */ }
    } catch (e) {
      console.warn('removeFromCatalogAndSearch error', e);
    }
    // notify UI to refresh
    try { window.dispatchEvent(new CustomEvent('catalog:changed', { detail: { popupId: String(popupId), removed: true } })); } catch {}
    try { window.dispatchEvent(new CustomEvent('search:changed', { detail: { popupId: String(popupId), removed: true } })); } catch {}
  }

  return (
  <div style={{ padding:'48px 20px 20px 20px', color:'#fff', background:'#071014', minHeight:'100vh', fontFamily:'Inter, Arial, sans-serif' }}>
      <ToastHost />
      {season0ConfirmOpen && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 20000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setSeason0ConfirmOpen(false)}>
          <div style={{ width: 520, maxWidth: 'calc(100% - 40px)', background: '#071014', color: '#fff', borderRadius: 12, padding: 18, border: '1px solid rgba(255,255,255,0.04)', boxShadow: '0 20px 60px rgba(0,0,0,0.6)' }} onClick={(e)=>e.stopPropagation()}>
            <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 8 }}>Přidat 0 řadu</div>
            <div>Opravdu chcete přidat řadu 0? Tím se vytvoří prázdná řada před současnou řadou 1.</div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16 }}>
              <button style={btn} onClick={() => setSeason0ConfirmOpen(false)}>Ne</button>
              <button style={btnPrimary} onClick={confirmAddSeason0}>Ano</button>
            </div>
          </div>
        </div>
      )}

      {/* Add-language modal (choose language then open Filemoon) */}
      {addLangModalOpen && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:120000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={()=>{ setAddLangModalOpen(false); setAddLangEpIdx(null); }}>
          <div style={{ width:420, maxWidth:'96%', background:'#0e1518', color:'#fff', borderRadius:10, border:'1px solid rgba(255,255,255,0.06)', boxShadow:'0 18px 48px rgba(0,0,0,0.6)' }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 14px', borderBottom:'1px solid rgba(255,255,255,0.04)' }}>
              <div style={{ fontWeight:800 }}>Přidat jazyk</div>
              <button onClick={()=>{ setAddLangModalOpen(false); setAddLangEpIdx(null); }} style={{ ...btn, background:'transparent' }}>Zavřít</button>
            </div>
            <div style={{ padding:12 }}>
              <div style={{ marginBottom:8, color:'#ddd' }}>Vyber jazyk, který chceš přidat. Po výběru budeš vyzván k výběru videa z Filemoon.</div>
              <div style={{ marginBottom:8 }}>
                <input
                  ref={addLangInputRef}
                  value={addLangQuery}
                  onChange={(e)=>setAddLangQuery(e.target.value)}
                  placeholder="Vyhledej jazyk (např. Čeština / English)"
                  onClick={() => { try { addLangInputRef.current && addLangInputRef.current.focus(); } catch (e) {} }}
                  style={{ width:'100%', padding:8, borderRadius:8, border:'1px solid rgba(255,255,255,0.06)', background:'#071014', color:'#fff' }}
                />
              </div>
              <div style={{ display:'flex', gap:8, flexWrap:'wrap', maxHeight:240, overflowY:'auto', paddingRight:6 }}>
                {LANGUAGE_LIST.filter(it => it.code !== 'cs').filter(it => {
                  if (!(addLangQuery || '').trim()) return true;
                  const q = (addLangQuery || '').toLowerCase();
                  return (it.name || '').toLowerCase().includes(q) || (it.code || '').toLowerCase().includes(q);
                }).map(entry => {
                  const code = entry.code;
                  const info = entry;
                  // disable entry if already present for this episode
                  const already = Array.isArray(model.episodes?.[addLangEpIdx]?.languages) ? model.episodes[addLangEpIdx].languages.find(l => l && l.code === code) : false;
                  return (
                    <div key={code} style={{ minWidth:160, background: already ? 'rgba(255,255,255,0.03)' : '#071014', padding:8, borderRadius:8, display:'flex', alignItems:'center', gap:8 }}>
                      <ReactCountryFlag svg countryCode={(info.country||'gb').toUpperCase()} style={{ width:28, height:18, display:'inline-block', borderRadius:2 }} title={info.name} />
                      <div style={{ flex:1 }}>
                        <div style={{ fontWeight:700 }}>{info.name}</div>
                        <div style={{ fontSize:12, opacity:0.8 }}>{code}</div>
                      </div>
                      <div>
                        <button
                          style={{ ...btn, background: already ? '#666' : btn.background }}
                          disabled={!!already}
                          onClick={(e)=>{ e.stopPropagation(); if (already) return; setFmLangForEp({ idx: addLangEpIdx, code, name: info.name, country: info.country }); setFmForEpIndex(null); setFmOpen(true); setFmQuery((model.episodes?.[addLangEpIdx]?.title) || model.title || ''); setAddLangModalOpen(false); setAddLangEpIdx(null); }}
                        >Vybrat z Filemoon</button>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div style={{ marginTop:12, display:'flex', justifyContent:'flex-end', gap:8 }}>
                <button style={{ ...btn, background:'transparent' }} onClick={()=>{ setAddLangModalOpen(false); setAddLangEpIdx(null); }}>Zrušit</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Language remove confirmation */}
      {langRemoveConfirmOpen && langRemoveTarget && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:120000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={()=>{ setLangRemoveConfirmOpen(false); setLangRemoveTarget(null); }}>
          <div style={{ width:380, maxWidth:'96%', background:'#0e1518', color:'#fff', borderRadius:10, border:'1px solid rgba(255,255,255,0.06)', boxShadow:'0 18px 48px rgba(0,0,0,0.6)' }} onClick={e=>e.stopPropagation()}>
            <div style={{ padding:14 }}>
              <div style={{ fontWeight:800, marginBottom:8 }}>Opravdu smazat jazyk?</div>
              <div style={{ marginBottom:16, color:'#ddd' }}>Smazáním jazyka odstraníš přiřazené video pro tento jazyk. Tuto akci lze provést znovu přidáním jazyka.</div>
              <div style={{ display:'flex', justifyContent:'flex-end', gap:8 }}>
                <button style={{ ...btn, background:'transparent' }} onClick={()=>{ setLangRemoveConfirmOpen(false); setLangRemoveTarget(null); }}>Zrušit</button>
                <button style={{ ...btn, background:'#d03535' }} onClick={()=>{ try { removeLangFromEp(langRemoveTarget.idx, langRemoveTarget.code); showToast('Jazyk smazán', 'warning'); } catch(e){} finally { setLangRemoveConfirmOpen(false); setLangRemoveTarget(null); } }}>Smazat</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {deleteSeasonConfirmOpen && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 20000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setDeleteSeasonConfirmOpen(false)}>
          <div style={{ width: 520, maxWidth: 'calc(100% - 40px)', background: '#071014', color: '#fff', borderRadius: 12, padding: 18, border: '1px solid rgba(255,255,255,0.04)', boxShadow: '0 20px 60px rgba(0,0,0,0.6)' }} onClick={(e)=>e.stopPropagation()}>
            <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 8 }}>Smazat řadu</div>
            <div>{seasonToDelete === 0 ? 'Smazat celou řadu 0?' : `Smazat celou řadu ${seasonToDelete}? Všechny epizody v této řadě budou odstraněny.`}</div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16 }}>
              <button style={btn} onClick={() => setDeleteSeasonConfirmOpen(false)}>Ne</button>
              <button style={btnWarn} onClick={performDeleteSeason}>Ano</button>
            </div>
          </div>
        </div>
      )}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:8, gap:8, flexWrap:'wrap' }}>
        <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', rowGap:8 }}>
          {/* Top-left save button removed per UX request; use floating primary button instead */}
        </div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 420px', gap:16, marginTop:16 }}>
        <div>
          <div style={panel}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6 }}>
              <div style={sectionTitle}>Základní info</div>
              <button onClick={() => setTmdbOpen(true)} style={btn}>Import z TMDb</button>
            </div>
            <div style={row}><label style={label}>Title<input style={input} value={model.title} onChange={e=>setField('title', e.target.value)} onMouseDown={e=>e.stopPropagation()} onClick={e=>e.currentTarget.focus()} /></label></div>
            <div style={{ ...row }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr auto', gap:8, alignItems:'end' }}>
                <label style={{...label, marginBottom:0}}>Hero image URL
                  <input style={input} value={model.heroImage} onChange={e=>setField('heroImage', e.target.value)} onMouseDown={e=>e.stopPropagation()} onClick={e=>e.currentTarget.focus()} />
                </label>
                <div>
                  <button style={btn} onClick={(e)=>{ e.stopPropagation(); openImagePicker('hero'); }}>Vybrat z TMDb</button>
                </div>
              </div>
            </div>
            <div style={{ ...row }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr auto', gap:8, alignItems:'end' }}>
                <label style={{...label, marginBottom:0}}>Series logo URL
                  <input style={input} value={model.seriesLogo} onChange={e=>setField('seriesLogo', e.target.value)} onMouseDown={e=>e.stopPropagation()} onClick={e=>e.currentTarget.focus()} />
                </label>
                <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                  <button style={btn} onClick={(e)=>{ e.stopPropagation(); (async ()=>{ try { setGoogleError(''); setGoogleResults([]); setGoogleOpen(true); setGoogleBusy(true); const q = (model.title || '').trim(); const results = await searchLogos(q || ''); setGoogleResults(results || []); } catch { setGoogleError('Vyhledávání selhalo.'); } finally { setGoogleBusy(false); } })(); }}>Vybrat z Google</button>
                </div>
              </div>
            </div>
            <div style={{ display:'flex', gap:12 }}>
              <label style={{...label, flex:1}}>Rok vydání<input style={input} value={model.year} onChange={e=>setField('year', e.target.value)} onMouseDown={e=>e.stopPropagation()} onClick={e=>e.currentTarget.focus()} /></label>
            </div>
            <div style={{ display:'flex', gap:12, alignItems:'center' }}>
              <label style={{...label, width:170}}>Video v popupu
                <input type="checkbox" checked={!!model.previewHasVideo} onChange={e=>setField('previewHasVideo', e.target.checked)} />
              </label>
              {model.previewHasVideo && (
                <label style={{...label, flex:1}}>Hero video URL
                  <input style={input} value={model.previewVideoUrl||''} onChange={e=>setField('previewVideoUrl', e.target.value)} onMouseDown={e=>e.stopPropagation()} onClick={e=>e.currentTarget.focus()} />
                </label>
              )}
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'180px 1fr 1fr', gap:12, alignItems:'center', marginTop:8 }}>
              <div style={{ color:'#cdd', fontSize:13 }}>Typ obsahu (povinné)</div>
              <div>
                <label style={{ marginRight:12, opacity: (editingId || model.lockContentType) ? 0.6 : 1 }} onMouseDown={(e)=>e.stopPropagation()} onClick={(e)=>e.currentTarget.querySelector('input')?.focus()}>
                  <input type="radio" name="ctype" disabled={!!editingId || !!model.lockContentType} checked={model.contentType==='serial'} onChange={()=>{
                    if (editingId || model.lockContentType) return; // lock when editing existing or locked
                    setField('contentType','serial');
                  }} /> Seriál
                </label>
                <label style={{ opacity: (editingId || model.lockContentType) ? 0.6 : 1 }} onMouseDown={(e)=>e.stopPropagation()} onClick={(e)=>e.currentTarget.querySelector('input')?.focus()}>
                  <input type="radio" name="ctype" disabled={!!editingId || !!model.lockContentType} checked={model.contentType==='film'} onChange={()=>{
                    if (editingId || model.lockContentType) return; // lock when editing existing or locked
                    setModel(m => {
                      // Ensure exactly one "film" row exists to hold videoUrl, title, thumb, desc (reuse first ep if any)
                      let eps = Array.isArray(m.episodes) && m.episodes.length ? [...m.episodes] : [{ season:1, index:1, title: m.title || 'Film', thumb:'', videoUrl:'', desc:'' }];
                      if (eps.length > 1) eps = [eps[0]];
                      return { ...m, contentType:'film', seasons: 1, episodes: eps };
                    });
                  }} /> Film
                </label>
              </div>
              <div></div>
              {/* Always allow tile (listThumb) and poster, for both series and films */}
              <div style={{ display:'grid', gridTemplateColumns:'1fr auto', gap:8, alignItems:'end' }}>
                <label style={{...label, marginBottom:0}}>Miniatura (dlaždice)
                  <input style={{...input, width:'100%'}} value={model.listThumb||''} onChange={e=>setField('listThumb', e.target.value)} placeholder="/images/... nebo https://..." onMouseDown={(e)=>e.stopPropagation()} onClick={(e)=>e.currentTarget.focus()} />
                </label>
                <div>
                  <button style={btn} onClick={(e)=>{ e.stopPropagation(); openImagePicker('thumb'); }}>Vybrat z TMDb</button>
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr auto', gap:8, alignItems:'end' }}>
                <label style={{...label, marginBottom:0}}>Poster (hledání)
                  <input style={input} value={model.searchPoster||''} onChange={e=>setField('searchPoster', e.target.value)} placeholder="/images/... nebo https://..." onMouseDown={(e)=>e.stopPropagation()} onClick={(e)=>e.currentTarget.focus()} />
                </label>
                <div>
                  <button style={btn} onClick={(e)=>{ e.stopPropagation(); openImagePicker('poster'); }}>Vybrat z TMDb</button>
                </div>
              </div>
            </div>
          </div>

          <div style={panel}>
            <div style={sectionTitle}>{model.contentType==='film' ? 'Film' : 'Řady a epizody'}</div>
            {model.contentType!=='film' ? (
              <>
                <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', marginBottom:8 }}>
                  {(model && (model.hasSeason0 || (Array.isArray(model.episodes) && model.episodes.some(ep => (ep.season || 1) === 0)))) && (
                    <button key={'s0'} style={{ ...chipBtn, background: (0)===selectedSeason ? '#2d8a34' : chipBtn.background }} onClick={()=>setSelectedSeason(0)}>Řada 0</button>
                  )}
                  {Array.from({ length: Math.max(1, Number(model.seasons)||1) }).map((_, si) => (
                    <button key={si} style={{ ...chipBtn, background: (si+1)===selectedSeason ? '#2d8a34' : chipBtn.background }} onClick={()=>setSelectedSeason(si+1)}>Řada {si+1}</button>
                  ))}
                  <button onClick={addSeason} onContextMenu={handleAddSeasonContext} style={btn}>+ Sezóna</button>
                  {Math.max(1, Number(model.seasons)||1) > 1 && (
                    <button onClick={()=>deleteSeason(selectedSeason)} style={btnWarn}>Smazat řadu {selectedSeason}</button>
                  )}
                </div>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <h4 style={{ marginTop:6, marginBottom:6 }}>Epizody — Řada {selectedSeason}</h4>
                  <button onClick={()=>addEpisode(selectedSeason)} style={btn}>+ Epizoda</button>
                </div>
              </>
            ) : (
              <div style={{ marginBottom:8, opacity:0.85 }}>Vyplň video URL (z Filemoon) pro film níže, epizody se zde nepoužívají.</div>
            )}
            {(() => {
              // Epizody aktuální řady
              const eps = (model.contentType!=='film' ? (model.episodes||[]).filter(ep=> (ep.season||1)===selectedSeason) : (model.episodes||[]));
              // Indexy v model.episodes (globální indexy)
              const globalIndexes = eps.map(ep => model.episodes.indexOf(ep));
              // Drag & drop hook pro epizody této řady
              const epDrag = useEpDragAndDrop(eps, async (newOrder) => {
                // Přemapovat pořadí v model.episodes podle nové sekvence v této řadě
                const newEpisodes = model.episodes.slice();
                globalIndexes.forEach((gIdx, i) => {
                  newEpisodes[gIdx] = { ...newOrder[i] };
                });
                setModel(m => ({ ...m, episodes: newEpisodes }));

                // Oprava: pokud má uživatel v continueSeries záznam pro tento seriál a epizodu, přeregistruj na nové playId a data epizody
                if (user && model && model.id) {
                  try {
                    const contList = await contApi.listSeries(user.uid, 30);
                    const cont = (contList||[]).find(c => String(c.popupId) === String(model.id));
                    if (cont && cont.playId) {
                      // Najdi epizodu podle původního playId v novém pořadí
                      const oldEp = newEpisodes.find(e => String(e.playId) === String(cont.playId));
                      // Najdi epizodu podle původního pořadí (season+index) v novém pořadí
                      const newEp = newEpisodes.find(e => (e.season||1) === (cont.season||1) && (e.index||1) === (cont.index||1));
                      if (newEp && oldEp && String(newEp.playId) !== String(cont.playId)) {
                        // playId se změnilo, přeregistruj záznam na nové playId a data epizody
                        await contApi.upsertSeries(user.uid, String(model.id), {
                          ...cont,
                          playId: newEp.playId,
                          path: `/play/${newEp.playId}`,
                          epTitle: newEp.title,
                          season: newEp.season,
                          index: newEp.index,
                          img: newEp.thumb || cont.img || '',
                        });
                      } else if (oldEp && oldEp.title && cont.epTitle !== oldEp.title) {
                        // Pokud se změnil jen název epizody
                        await contApi.upsertSeries(user.uid, String(model.id), {
                          ...cont,
                          epTitle: oldEp.title
                        });
                      }
                    }
                  } catch (e) { /* ignore */ }
                }
              });
              return eps.map((ep, i) => {
                const idx = model.episodes.indexOf(ep);
                const isDragged = epDrag.draggedIdx === i && epDrag.dragging;
                const isOver = epDrag.dragOverIdx === i && epDrag.dragging && epDrag.draggedIdx !== epDrag.dragOverIdx;
                return (
                  <div
                    key={i}
                    style={{
                      marginTop:14,
                      border:'1px solid #1f2830',
                      borderRadius:10,
                      background: isDragged ? '#2d8a34' : isOver ? '#3a3f4a' : '#0b0e10',
                      opacity: isDragged ? 0.7 : 1,
                      boxShadow: isDragged ? '0 0 0 2px #2d8a34' : isOver ? '0 0 0 2px #3a3f4a' : undefined,
                      transition: 'background 0.15s, box-shadow 0.15s, opacity 0.15s',
                      cursor: epDrag.dragging ? 'grabbing' : 'grab',
                    }}
                    onMouseEnter={() => epDrag.handleMouseEnter(i)}
                    onMouseUp={() => epDrag.handleMouseUp(i)}
                  >
                    <div
                      style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 12px', cursor:'pointer', borderBottom: openEps[idx] ? '1px solid #1f2830' : 'none' }}
                      onClick={() => setOpenEps(prev => ({ ...prev, [idx]: !prev[idx] }))}
                    >
                      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        {/* Drag handle */}
                        <span
                          style={{ cursor: 'grab', display: 'flex', alignItems: 'center', userSelect: 'none', marginRight: 2 }}
                          title="Přetáhni pro změnu pořadí"
                          onMouseDown={e => { e.stopPropagation(); epDrag.handleMouseDown(i); }}
                        >
                          <RxDragHandleDots2 color="#aaa" size={22} />
                        </span>
                        {model.contentType!=='film' && <div style={{ width:28, textAlign:'center', color:'rgba(255,255,255,0.65)', fontWeight:700 }}>{i+1}</div>}
                        <div style={{ fontWeight:700 }}>{model.contentType==='film' ? (ep.title || model.title || 'Film') : (ep.title || 'Bez názvu')}</div>
                      </div>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <button onClick={(e)=>{ e.stopPropagation(); setOpenEps(prev => ({ ...prev, [idx]: !prev[idx] })); }} style={btn}>{openEps[idx] ? 'Skrýt' : 'Upravit'}</button>
                        <button onClick={(e)=>{ e.stopPropagation(); delEp(idx); }} style={{ ...btn, background:'#933' }}>Smazat</button>
                      </div>
                    </div>
                    {openEps[idx] && (
                      <div style={{ padding:12 }}>
                        <div style={{ display:'grid', gridTemplateColumns: model.contentType==='film' ? '1fr' : '1fr 1fr', gap:10 }}>
                          <label style={label}>Název<input style={input} value={ep.title} onChange={e=>updEp(idx, { title:e.target.value })} onMouseDown={e=>e.stopPropagation()} onClick={e=>e.currentTarget.focus()} /></label>
                          {model.contentType!=='film' && (
                            <label style={label}>Řada<input type="number" min={1} style={input} value={ep.season||1} onChange={e=>updEp(idx, { season:Number(e.target.value)||1 })} onMouseDown={e=>e.stopPropagation()} onClick={e=>e.currentTarget.focus()} /></label>
                          )}
                          {model.contentType!=='film' && (
                            <div style={{ display:'grid', gridTemplateColumns:'1fr auto', gap:8, alignItems:'end' }}>
                              <label style={{...label, marginBottom:0}}>Miniatura URL
                                <input style={{...input, width:'100%'}} value={ep.thumb} onChange={e=>updEp(idx, { thumb:e.target.value })} onMouseDown={e=>e.stopPropagation()} onClick={e=>e.currentTarget.focus()} />
                              </label>
                              <div>
                                <button style={btn} onClick={(e)=>{ e.stopPropagation(); openImagePicker('ep', { season: ep.season||1, index: ep.index||1, idx }); }}>Vybrat z TMDb</button>
                              </div>
                            </div>
                          )}
                          <div style={{ display:'grid', gridTemplateColumns:'1fr auto', gap:8 }}>
                            <label style={{...label, marginBottom:0}}>Video (pouze z Filemoon)
                              <input style={{...input, opacity:0.85}} value={ep.videoUrl} readOnly onMouseDown={e=>e.stopPropagation()} onClick={e=>e.currentTarget.select()} placeholder="Vyber z Filemoon" />
                            </label>
                            <div style={{ alignSelf:'end' }}>
                              <button
                                style={btn}
                                title="Vyhledat na Filemoon"
                                onClick={(e)=>{ e.stopPropagation(); setFmForEpIndex(idx); setFmOpen(true); setFmQuery(ep.title || model.title || ''); setFmResults([]); setFmError(''); }}
                              >Vybrat z Filemoon</button>
                            </div>
                          </div>
                            <div style={{ marginTop:8, display:'flex', alignItems:'center', gap:10, flexDirection:'column' }}>
                              {/* Languages editor for this episode */}
                              <div style={{ display:'flex', gap:8, alignItems:'center', marginTop:6, cursor:'default', marginLeft:-8 }}>
                                <div style={{ color:'#ddd', fontSize:13 }}>Jazyky:</div>
                                <div style={{ display:'flex', gap:8, alignItems:'center', cursor:'default' }}>
                                  {(Array.isArray(ep.languages) ? ep.languages : []).map(l => (
                                    <div key={l.code} style={{ display:'flex', alignItems:'center', gap:12, background:'#0b0e10', padding:'8px', borderRadius:8, minWidth:240, cursor:'default' }}>
                                      {(() => {
                                        const raw = l.flag || l.country || (LANG_MAP[l.code] && LANG_MAP[l.code].country) || '';
                                        if (!raw) return <ReactCountryFlag svg countryCode={'GB'} style={{ width:22, height:14, display:'inline-block', borderRadius:2 }} />;
                                        // if raw looks like a URL, keep using img for backward compatibility
                                        if (raw.indexOf('/') >= 0 || raw.indexOf('.') >= 0) {
                                          return <img src={raw} alt="" style={{ width:22, height:14, objectFit:'cover', borderRadius:2 }} />;
                                        }
                                        // otherwise assume it's a country code
                                        return <ReactCountryFlag svg countryCode={String(raw).toUpperCase()} style={{ width:22, height:14, display:'inline-block', borderRadius:2 }} />;
                                      })()}
                                      <div style={{ flex:1, minWidth:0 }}>
                                        <div style={{ color:'#fff', fontSize:13, fontWeight:700 }}>{l.name || (LANG_MAP[l.code] && LANG_MAP[l.code].name)}</div>
                                        <div style={{ marginTop:4 }}>
                                          {l.videoUrl ? (
                                            <div style={{ display:'flex', gap:8, alignItems:'center', fontSize:12, color:'#cdd', overflow:'hidden' }}>
                                              <a href={l.videoUrl} target="_blank" rel="noopener noreferrer" style={{ color:'#cdd', textDecoration:'underline', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', display:'inline-block', maxWidth:220 }}>{l.videoUrl}</a>
                                              <button style={{ ...btn, padding:'6px 8px', fontSize:12 }} onClick={(e)=>{ e.stopPropagation(); try { navigator.clipboard.writeText(l.videoUrl||''); showToast('URL zkopírováno', 'success'); } catch { showToast('Nelze zkopírovat', 'error'); } }}>Kopírovat</button>
                                            </div>
                                          ) : (
                                            <div style={{ fontSize:12, color:'#888' }}>Žádné video</div>
                                          )}
                                        </div>
                                      </div>
                                      <div style={{ display:'flex', gap:6, alignItems:'center' }}>
                                        <button style={{ ...btn }} onClick={(e)=>{ e.stopPropagation(); /* open Filemoon to replace this language video */ setFmLangForEp({ idx, code: l.code }); setFmForEpIndex(null); setFmOpen(true); setFmQuery(ep.title || model.title || ''); }}>Změnit</button>
                                        <button style={{ ...btn, background:'#2d8a34' }} onClick={(e)=>{ e.stopPropagation(); setLangAsDefault(idx, l.code); }}>Nastavit výchozí</button>
                                        <button style={{ ...btn, background:'#444' }} onClick={(e)=>{ e.stopPropagation(); setLangRemoveTarget({ idx, code: l.code }); setLangRemoveConfirmOpen(true); }}>Smazat</button>
                                      </div>
                                    </div>
                                  ))}
                                  <div style={{ cursor:'default' }}>
                                    <button style={btn} onClick={(e)=>{ e.stopPropagation(); setAddLangEpIdx(idx); setAddLangModalOpen(true); }}>+ Přidat jazyk</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          {model.contentType!=='film' && (
                            <label style={{...label, gridColumn:'1 / -1'}}>Popis<textarea
                              style={{...input, minHeight:80, resize:'none', overflow:'hidden' }}
                              value={ep.desc||''}
                              onChange={e=>{ updEp(idx, { desc:e.target.value }); autoGrow(e.currentTarget); }}
                              onFocus={e=>autoGrow(e.currentTarget)}
                              onMouseDown={e=>e.stopPropagation()}
                              onClick={e=>e.currentTarget.focus()}
                            /></label>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                );
              });
            })()}
          </div>
        </div>

        <div style={{ marginLeft:12 }}>
          <h3 style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:8 }}>
            <span>Uložené popupy</span>
            <span>
              <button style={btn} onClick={()=>{ setCollectionOpen(true); setTimeout(()=>collectionInputRef.current?.focus(), 0); }}>Celá sbírka</button>
            </span>
          </h3>

          {/* Search bar with forced focus on click wrapper */}
          <div style={{ marginBottom:8 }} onClick={(e)=>{ e.stopPropagation(); savedSearchInputRef.current?.focus(); }}>
            <label style={{...label, marginBottom:4}}>Vyhledat v uložených</label>
            <input
              ref={savedSearchInputRef}
              style={input}
              value={savedSearch}
              onChange={(e)=>{ setSavedSearch(e.target.value); setSavedPage(1); }}
              placeholder="Hledat podle názvu"
            />
          </div>

          {loading ? <div>Načítám…</div> : error ? <div style={{ color:'#f88' }}>{error}</div> : (
            <div style={{ border:'1px solid #1f2830', borderRadius:8, overflow:'hidden' }}>
              {/* Paged list: 4 per page */}
              <div style={{ maxHeight:'60vh', overflow:'auto' }}>
                {(() => {
                  const q = (savedSearch||'').trim().toLowerCase();
                  const filtered = q ? (list||[]).filter(it => (it.title||'').toLowerCase().includes(q)) : (list||[]);
                  const total = filtered.length;
                  const totalPages = Math.max(1, Math.ceil(total / perPage));
                  const page = Math.min(Math.max(1, savedPage), totalPages);
                  const start = (page - 1) * perPage;
                  const view = filtered.slice(start, start + perPage);
                  return (
                    <>
                      {total === 0 && <div style={{ padding:10, color:'#bbb' }}>Žádné</div>}
                      {view.map(it => (
                        <div key={it.id} style={{ padding:12, borderBottom:'1px solid #1f2830' }}>
                          <div style={{ display:'flex', justifyContent:'space-between', gap:8 }}>
                            <div>
                              <div style={{ fontWeight:600 }}>{it.title}</div>
                              <div style={{ fontSize:12, opacity:0.8 }}>{it.year}{it.contentType==='film' ? '' : ` • ${it.seasons} řad`}</div>
                            </div>
                            <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'nowrap' }}>
                              <button style={btn} onClick={()=>{ setModel(it); setEditingId(it.id); const p=new URLSearchParams(window.location.search||''); p.set('preview', String(it.id)); const newUrl=`${window.location.pathname}?${p.toString()}`; window.history.pushState({}, '', newUrl); window.dispatchEvent(new CustomEvent('preview:open', { detail: { id: String(it.id) } })); setPreviewOpenState(true); }}>Otevřít</button>
                              <button style={btnPrimary} onClick={()=>edit(it)}>Upravit</button>
                              <button style={btn} onClick={()=>copyLink(it.id)} title="Zkopírovat odkaz">
                                {copiedKey === String(it.id) ? 'Zkopírováno' : 'Odkaz'}
                              </button>
                              <button style={{ ...btnWarn }} onClick={()=>remove(it.id)}>Smazat</button>
                            </div>
                          </div>
                        </div>
                      ))}
                      {/* Pagination controls */}
                      {totalPages > 1 && (
                        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:8 }}>
                          <button style={btn} disabled={page<=1} onClick={()=>setSavedPage(p=>Math.max(1,p-1))}>◀ Předchozí</button>
                          <div style={{ opacity:0.85 }}>Strana {page} / {totalPages}</div>
                          <button style={btn} disabled={page>=totalPages} onClick={()=>setSavedPage(p=>Math.min(totalPages,p+1))}>Další ▶</button>
                        </div>
                      )}
                    </>
                  );
                })()}
              </div>
            </div>
          )}
        </div>
      </div>

      {previewOpen && previewItem && (
  <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', zIndex:99999, display:'flex', alignItems:'flex-start', justifyContent:'center', overflowY:'auto', padding:'36px 0', overscrollBehavior:'contain', WebkitOverflowScrolling:'touch' }} onClick={()=>{ setPreviewSeasonsOpen(false); const p=new URLSearchParams(window.location.search||''); p.delete('preview'); const newUrl=`${window.location.pathname}${p.toString()?`?${p.toString()}`:''}`; window.history.pushState({}, '', newUrl); }}>
          <div style={{ width:'62%', maxWidth:760, margin:'0 auto', background:'#071014', borderRadius:12, overflow:'visible', color:'#fff', position:'relative', boxShadow:'0 20px 60px rgba(0,0,0,0.6)' }} onClick={e=>e.stopPropagation()}>
            {/* Close (X) button top-right */}
            <button
              aria-label="Zavřít"
              onClick={()=>{ setPreviewSeasonsOpen(false); const p=new URLSearchParams(window.location.search||''); p.delete('preview'); const newUrl=`${window.location.pathname}${p.toString()?`?${p.toString()}`:''}`; window.history.pushState({}, '', newUrl); }}
              style={{ position:'absolute', top:10, right:10, width:36, height:36, borderRadius:'50%', border:'2px solid #000', background:'rgba(0,0,0,0.55)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:5, cursor:'pointer' }}
            >
              <IoClose color="#fff" size={20} />
            </button>
            {(() => { const isFilm = (String(previewItem.contentType||'')==='film'); return (
            <div style={{ position:'relative', height: isFilm ? 380 : 240 }}>
              {/* Image layer */}
              <div style={{ position:'absolute', inset:0, backgroundImage:`url(${previewItem.heroImage})`, backgroundSize:'cover', backgroundPosition:'center', opacity: previewVideoActive ? 0 : 1, transition:'opacity .4s ease' }} />
              {/* Optional video layer */}
              {previewItem.previewHasVideo && previewItem.previewVideoUrl && (
                <div style={{ position:'absolute', inset:0, opacity: previewVideoActive ? 1 : 0, transition:'opacity .4s ease' }}>
                  <video
                    ref={previewVideoRef}
                    src={previewItem.previewVideoUrl}
                    style={{ width:'100%', height:'100%', objectFit:'cover' }}
                    playsInline
                    autoPlay
                    muted={previewVideoMuted}
                    onEnded={() => { setPreviewVideoActive(false); }}
                  />
                  {/* Volume toggle */}
                  <button
                    aria-label={previewVideoMuted ? 'Zapnout zvuk' : 'Vypnout zvuk'}
                    onClick={(e) => {
                      e.stopPropagation();
                      const v = previewVideoRef.current;
                      if (!v) return;
                      if (previewVideoMuted) {
                        v.muted = false;
                        setPreviewVideoMuted(false);
                        v.play().catch(()=>{});
                      } else {
                        v.muted = true;
                        setPreviewVideoMuted(true);
                      }
                    }}
                    style={{ position:'absolute', right:12, bottom:12, width:36, height:36, borderRadius:'50%', border:'1px solid rgba(255,255,255,0.35)', background:'rgba(0,0,0,0.45)', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}
                  >
                    {previewVideoMuted ? <LuVolumeOff color="#fff" size={18} /> : <LuVolume2 color="#fff" size={18} />}
                  </button>
                </div>
              )}
              <div style={{ position:'absolute', left:20, bottom:16, right:20 }}>
                {previewItem.seriesLogo && <img src={previewItem.seriesLogo} alt="" style={{ height:44 }} />}
                <h2 style={{ margin:6 }}>{previewItem.title}</h2>
                <div style={{ opacity:0.9, marginBottom:6 }}>{previewItem.year}{isFilm ? '' : ` • ${previewItem.seasons} řad`}</div>
                <div style={{ marginTop:10, display:'flex', gap:8 }}>
                  <button
                    style={pillPrimary}
                    onClick={async (e) => {
                      e.stopPropagation();
                      try {
                        let ep;
                        if (isFilm) {
                          ep = (previewItem.episodes || [])[0];
                        } else {
                          const seasonNum = selectedSeason || 1;
                          const eps = (previewItem.episodes || []).filter(x => (x.season || 1) === seasonNum);
                          ep = eps[0];
                        }
                        if (!ep) return;
                        if (ep.playId) {
                          window.location.href = `/play/${ep.playId}`;
                          return;
                        }
                        if (!ep.videoUrl) return;
                        const url = toEmbedAutoplay(ep.videoUrl);
                        const id = genPlayId();
                        const path = `/play/${id}`;
                        const title = isFilm ? (previewItem.title || 'Přehrát film') : `${previewItem.title || 'Přehrát'} — S${ep.season || (selectedSeason||1)}E${ep.index || 1}`;
                        await pagesApi.addPage({ path, title, content: JSON.stringify({ url, popupId: String(editingId||''), showTitle: previewItem.title || 'Přehrát', epTitle: isFilm ? (ep.title || previewItem.title || 'Film') : (ep.title || `S${ep.season || (selectedSeason||1)}E${ep.index || 1}`), season: isFilm ? null : (ep.season || (selectedSeason||1)), index: isFilm ? null : (ep.index || 1), img: previewItem.listThumb || previewItem.searchPoster || previewItem.heroImage || ep.thumb || '', vipOnly: !!ep.vipOnly }) });
                        // Update state: if previewing draft (model), update model; otherwise update list
                        if (previewParam === 'draft') {
                          const idxGlobal = (model.episodes || []).indexOf(ep);
                          if (idxGlobal >= 0) updEp(idxGlobal, { playId: id });
                        } else {
                          setList(arr => arr.map(p => {
                            if (String(p.id) !== String(previewParam)) return p;
                            const epsAll = Array.isArray(p.episodes) ? p.episodes.map(e => {
                              if ((e.season||1)===(ep.season||1) && (e.index||0)===(ep.index||0) && (e.title||'')===(ep.title||'')) return { ...e, playId: id, videoUrl: url };
                              return e;
                            }) : p.episodes;
                            return { ...p, episodes: epsAll };
                          }));
                        }
                        window.location.href = path;
                      } catch (_) {}
                    }}
                  >{isFilm ? 'Přehrát film' : 'Přehrát 1. díl'}</button>
                  <button style={previewItem.watchlist ? pillSecondaryOn : pillSecondary}>{previewItem.watchlist ? '✓ Watchlist' : '+ Watchlist'}</button>
                </div>
              </div>
              </div>
            ); })()}
            <div style={{ padding:12 }}>
                {/* Film details block */}
                {(() => { const isFilm = (String(previewItem.contentType||'')==='film'); if (!isFilm) return null; const m = previewItem; const mins = Number(m.runtimeMins)||0; const hours = Math.floor(mins/60); const minsLeft = mins%60; const runtimeStr = mins>0 ? `${hours>0?`${hours} h `:''}${minsLeft>0?`${minsLeft} min`:hours>0?'':''}` : ''; const genres = Array.isArray(m.genres)?m.genres.slice(0,3):[]; return (
                  <div style={{ background:'#0e141a', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:'12px 14px', marginBottom:12 }}>
                    <div style={{ fontWeight:800, fontSize:18, marginBottom:6 }}>{m.title}</div>
                    <div style={{ opacity:0.9, fontSize:14, marginBottom:6 }}>
                      <span>{m.year}</span>
                      {runtimeStr && <span> • {runtimeStr}</span>}
                      {!!genres.length && <span> • {genres.join(', ')}</span>}
                    </div>
                    {!!(m.overview||'').trim() && <div style={{ fontSize:14, lineHeight:1.4, opacity:0.95 }}>{m.overview}</div>}
                  </div>
                ); })()}
              {(() => { const isFilm = (String(previewItem.contentType||'')==='film'); return !isFilm; })() && (
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <div style={{ position:'relative' }}>
                    <button style={{ ...btn, padding:'10px 16px', fontSize:15 }} onClick={()=>setPreviewSeasonsOpen(v=>!v)}>Řada {selectedSeason}</button>
                    {previewSeasonsOpen && (
                      <div style={{ position:'absolute', top:'100%', left:0, background:'#0b0e10', border:'1px solid #1f2830', borderRadius:8, overflowY:'auto', zIndex:1000001, minWidth:220, maxHeight:'60vh', boxShadow:'0 16px 40px rgba(0,0,0,0.45)' }}>
                        {Array.from({ length: Math.max(1, Number(previewItem.seasons)||1) }).map((_, si) => {
                          const seasonNum = si + 1;
                          const count = (previewItem.episodes||[]).filter(ep => (ep.season||1)===seasonNum).length;
                          return (
                            <div key={si}>
                              <button style={{ ...btn, padding:'10px 12px', fontSize:15, display:'flex', gap:8, alignItems:'baseline', width:'100%', textAlign:'left', borderRadius:0, background: seasonNum===selectedSeason ? '#233' : '#0b0e10' }} onClick={()=>{ setSelectedSeason(seasonNum); setPreviewSeasonsOpen(false); }}>
                                <span style={{ fontWeight:800 }}>Řada {seasonNum}</span>
                                <span style={{ opacity:0.8, fontSize:14 }}>({count} dílů)</span>
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {(() => { const isFilm = (String(previewItem.contentType||'')==='film'); return !isFilm; })() && (
              <div style={{ marginTop:12 }}>
                {/* Hover styles for play overlay on thumbnails */}
                <style>{`
                  .ep-row { display:flex; gap:16px; padding:16px 0; align-items:center; text-decoration:none; color:#fff; }
                  .ep-row.clickable { cursor: pointer; }
                  .ep-row + .ep-row { border-top: 1px solid rgba(255,255,255,0.08); }
                  .ep-num { width:42px; flex:0 0 42px; text-align:center; color:rgba(255,255,255,0.6); font-weight:700; font-size:24px; }
                  .ep-thumb { position:relative; width:160px; height:90px; flex:0 0 160px; border-radius:8px; overflow:hidden; background-size:cover; background-position:center; }
                  .ep-thumb .play-overlay { position:absolute; inset:0; display:flex; align-items:center; justify-content:center; opacity:0; transition:opacity .15s ease; background:linear-gradient(0deg, rgba(0,0,0,0.18), rgba(0,0,0,0.18)); }
                  .ep-row:hover .ep-thumb .play-overlay { opacity:1; }
                  .ep-text .ep-title { font-weight:800; font-size:17px; }
                  .ep-text .ep-desc { font-size:14px; opacity:0.92; }
                `}</style>
                {(() => {
                  const seasonEps = (previewItem.episodes||[]).filter(ep => (ep.season||1)===selectedSeason);
                  return seasonEps.map((ep, i) => {
                    const playHref = ep.playId ? `/play/${ep.playId}` : undefined;
                    const RowTag = playHref ? 'a' : 'div';
                    const common = { className:`ep-row ${playHref ? 'clickable' : ''}`.trim(), href: playHref, onClick: async (e) => {
                      // Fallback: if no playId but we have a videoUrl, create a play page and navigate
                      if (playHref) return;
                      if (ep.videoUrl) {
                        e.preventDefault();
                        try {
                          const idxGlobal = model.episodes.indexOf(ep);
                          const url = toEmbedAutoplay(ep.videoUrl);
                          const id = genPlayId();
                          const path = `/play/${id}`;
                          const title = model.contentType==='film' ? (model.title || 'Přehrát film') : `${model.title || 'Přehrát'} — S${ep.season || selectedSeason}E${ep.index || (i+1)}`;
                          await pagesApi.addPage({ path, title, content: JSON.stringify({ url, popupId: String(editingId||''), showTitle: model.title || 'Přehrát', epTitle: model.contentType==='film' ? (ep.title || model.title || 'Film') : (ep.title || `S${ep.season || selectedSeason}E${ep.index || (i+1)}`), season: model.contentType==='film' ? null : (ep.season || selectedSeason), index: model.contentType==='film' ? null : (ep.index || (i+1)), img: model.listThumb || model.searchPoster || model.heroImage || ep.thumb || '', vipOnly: !!ep.vipOnly }) });
                          updEp(idxGlobal, { playId: id });
                          window.location.href = path;
                        } catch (_) {}
                      }
                    } };
                    return (
                      <RowTag key={i} {...common}>
                        <div className="ep-num">{i+1}</div>
                        <div className="ep-thumb" style={{ backgroundImage:`url(${ep.thumb})` }}>
                          <div className="play-overlay">
                            <IoPlayCircleOutline color="#fff" size={54} />
                          </div>
                        </div>
                        <div className="ep-text">
                          <div className="ep-title">{ep.title}</div>
                          <div className="ep-desc">{ep.desc}</div>
                        </div>
                      </RowTag>
                    );
                  });
                })()}
              </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* TMDb image picker modal */}
      {imgPickerOpen && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:100001, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={()=>setImgPickerOpen(false)}>
          <div style={{ width:'860px', maxWidth:'96%', maxHeight:'85vh', display:'flex', flexDirection:'column', background:'#10161e', color:'#fff', borderRadius:12, border:'1px solid rgba(255,255,255,0.06)', boxShadow:'0 20px 60px rgba(0,0,0,0.6)' }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 14px', borderBottom:'1px solid rgba(255,255,255,0.06)' }}>
              <div style={{ fontWeight:800 }}>{imgPickerKind==='poster' ? 'Vybrat plakát z TMDb' : 'Vybrat pozadí z TMDb'}</div>
              <div style={{ display:'flex', gap:8 }}>
                <button style={btn} onClick={()=>openImagePicker(imgPickerKind)}>Obnovit</button>
                <button onClick={()=>setImgPickerOpen(false)} style={{ ...btn, background:'transparent' }}>Zavřít</button>
              </div>
            </div>
            <div style={{ padding:14, overflow:'auto' }}>
              {imgPickerError && <div style={{ color:'#f88', marginBottom:8 }}>{imgPickerError}</div>}
              {imgPickerBusy && <div>Načítám obrázky…</div>}
              {!imgPickerBusy && !imgPickerError && (
                <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(180px, 1fr))', gap:10 }}>
                  {imgPickerItems.map((it, i) => (
                    <button key={i} onClick={()=>{
                      if (imgPickerKind==='poster') setField('searchPoster', it.url);
                      else if (imgPickerKind==='thumb') setField('listThumb', it.url);
                      else if (imgPickerKind==='hero') setField('heroImage', it.url);
                      else if (imgPickerKind==='logo') setField('seriesLogo', it.url);
                      else if (imgPickerKind==='ep' && imgPickerEp && imgPickerEp.idx!=null) {
                        updEp(imgPickerEp.idx, { thumb: it.url });
                      }
                      setImgPickerOpen(false);
                    }} style={{ background:'transparent', border:'1px solid rgba(255,255,255,0.08)', borderRadius:8, padding:0, overflow:'hidden', cursor:'pointer' }} title="Vybrat">
                      <img src={it.url} alt="tmdb" style={{ width:'100%', height: imgPickerKind==='poster' ? 270 : 140, objectFit:'cover', display:'block' }} />
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Google logo picker modal */}
      {googleOpen && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:100000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={()=>setGoogleOpen(false)}>
          <div style={{ width:'780px', maxWidth:'96%', background:'#10161e', color:'#fff', borderRadius:12, border:'1px solid rgba(255,255,255,0.06)', boxShadow:'0 20px 60px rgba(0,0,0,0.6)' }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 14px', borderBottom:'1px solid rgba(255,255,255,0.06)' }}>
              <div style={{ fontWeight:800 }}>Vybrat logo z Google</div>
              <button onClick={()=>setGoogleOpen(false)} style={{ ...btn, background:'transparent' }}>Zavřít</button>
            </div>
            <div style={{ padding:14 }}>
              <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:10 }}>
                <input
                  placeholder="Název seriálu + logo"
                  defaultValue={model.title||''}
                  style={{ ...input, flex:1 }}
                  onMouseDown={e=>e.stopPropagation()}
                  onKeyDown={async (e)=>{ if (e.key==='Enter') { e.preventDefault(); try { setGoogleBusy(true); setGoogleError(''); setGoogleResults([]); const val = e.currentTarget.value || model.title || ''; const res = await searchLogos(val); setGoogleResults(res||[]); } catch { setGoogleError('Vyhledávání selhalo.'); } finally { setGoogleBusy(false); } } }}
                />
                <button style={btnPrimary} onClick={async ()=>{ try { setGoogleBusy(true); setGoogleError(''); setGoogleResults([]); const res = await searchLogos(model.title || ''); setGoogleResults(res||[]); } catch { setGoogleError('Vyhledávání selhalo.'); } finally { setGoogleBusy(false); } }}>Hledat</button>
              </div>
              {googleError && <div style={{ color:'#f88', marginTop:8 }}>{googleError}</div>}
              {googleBusy && <div style={{ marginTop:8 }}>Načítám…</div>}
              {!!googleResults?.length && (
                <div style={{ marginTop:12, maxHeight:'60vh', overflowY:'auto', border:'1px solid rgba(255,255,255,0.06)', borderRadius:8 }}>
                  <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(180px, 1fr))', gap:10, padding:10 }}>
                    {googleResults.map((r, i) => (
                      <button key={String(i)} onClick={()=>{ setField('seriesLogo', r.url); setGoogleOpen(false); }} style={{ background:'transparent', border:'1px solid rgba(255,255,255,0.08)', borderRadius:8, padding:0, overflow:'hidden', cursor:'pointer' }} title="Vybrat">
                        <div style={{ position:'relative', paddingTop:'56%' }}>
                          <img src={r.thumb || r.url} alt="logo" style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'contain', background:'#000' }} />
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Cloudflare R2 picker modal */}
      {r2Open && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:100000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={()=>setR2Open(false)}>
          <div style={{ width:'860px', maxWidth:'96%', maxHeight:'85vh', display:'flex', flexDirection:'column', background:'#10161e', color:'#fff', borderRadius:12, border:'1px solid rgba(255,255,255,0.06)', boxShadow:'0 20px 60px rgba(0,0,0,0.6)' }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 14px', borderBottom:'1px solid rgba(255,255,255,0.06)' }}>
              <div style={{ fontWeight:800 }}>Cloudflare R2 – loga</div>
              <div style={{ display:'flex', gap:8 }}>
                <button onClick={async ()=>{ try { setR2Busy(true); setR2Error(''); const items = await r2.listObjects(''); setR2Items(items||[]); } catch { setR2Error('Načtení selhalo.'); } finally { setR2Busy(false); } }} style={btn}>Obnovit</button>
                <button onClick={()=>setR2Open(false)} style={{ ...btn, background:'transparent' }}>Zavřít</button>
              </div>
            </div>
            <div style={{ padding:14, overflow:'auto' }}>
              {r2Error && <div style={{ color:'#f88', marginBottom:8 }}>{r2Error}</div>}
              {r2Busy && <div>Načítám…</div>}
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(180px, 1fr))', gap:10 }}>
                {(r2Items||[]).map((it,i)=>{
                  const key = it.key || it.Key || '';
                  if (!key) return null;
                  const url = it.url || undefined;
                  return (
                    <div key={key+String(i)} style={{ border:'1px solid rgba(255,255,255,0.08)', borderRadius:8, overflow:'hidden', background:'#071014' }}>
                      <div style={{ position:'relative', paddingTop:'56%', background:'#000' }}>
                        {url && <img src={url} alt="logo" style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'contain' }} onClick={()=>{ setField('seriesLogo', url); setR2Open(false); }} />}
                      </div>
                      <div style={{ display:'flex', gap:6, padding:8, borderTop:'1px solid rgba(255,255,255,0.06)' }}>
                        <button style={btn} onClick={()=>{ if (url) { setField('seriesLogo', url); setR2Open(false); } }}>Vybrat</button>
                        <button style={{ ...btn, background:'#d03535' }} onClick={async ()=>{ if (!key) return; if (!confirm('Smazat tento soubor z R2?')) return; try { setR2Busy(true); await r2.deleteObject(key); const items = await r2.listObjects('logos/'); setR2Items(items||[]); } catch { setR2Error('Smazání selhalo.'); } finally { setR2Busy(false); } }}>Smazat</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Filemoon picker modal */}
      {fmOpen && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:100000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={()=>setFmOpen(false)}>
          <div style={{ width:'780px', maxWidth:'96%', background:'#10161e', color:'#fff', borderRadius:12, border:'1px solid rgba(255,255,255,0.06)', boxShadow:'0 20px 60px rgba(0,0,0,0.6)' }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 14px', borderBottom:'1px solid rgba(255,255,255,0.06)' }}>
              <div style={{ fontWeight:800 }}>Vybrat video z Filemoon</div>
              <button onClick={()=>setFmOpen(false)} style={{ ...btn, background:'transparent' }}>Zavřít</button>
            </div>
            <div style={{ padding:14 }}>
              <div style={{ display:'flex', gap:8, marginBottom:10 }}>
                <button style={{ ...btn, background: fmTab==='search' ? '#2d8a34' : btn.background }} onClick={()=>setFmTab('search')}>Hledat</button>
                <button style={{ ...btn, background: fmTab==='folders' ? '#2d8a34' : btn.background }} onClick={async ()=>{
                  setFmTab('folders');
                  setFmError('');
                  try {
                    setFmBusy(true);
                    const r = await fetch(`${apiBase}/filemoon/folders`);
                    if (!r.ok) throw new Error('bad');
                    const j = await r.json();
                    setFmFolders(Array.isArray(j) ? j : []);
                  } catch (_) { setFmError('Nepodařilo se načíst složky.'); }
                  finally { setFmBusy(false); }
                }}>Moje složky</button>
              </div>

              {fmTab==='search' && (
              <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                <input
                  value={fmQuery}
                  onChange={e=>setFmQuery(e.target.value)}
                  placeholder="Zadej hledaný název (např. Miraculous S01E01)"
                  style={{ ...input, flex:1 }}
                  onMouseDown={e=>e.stopPropagation()}
                  onKeyDown={async (e)=>{ if (e.key==='Enter') { e.preventDefault(); await doFilemoonSearch(); } }}
                />
                <button style={btnPrimary} onClick={doFilemoonSearch}>Hledat</button>
              </div>
              )}
              {fmError && <div style={{ color:'#f88', marginTop:8 }}>{fmError}</div>}
              {fmBusy && <div style={{ marginTop:8 }}>Načítám…</div>}
                    {fmTab==='search' && !!fmResults?.length && (
                <div style={{ marginTop:12 }}>
                  <div style={{ fontWeight:700, marginBottom:8 }}>Výsledky</div>
                  <div style={{ maxHeight:'60vh', overflowY:'auto', border:'1px solid rgba(255,255,255,0.06)', borderRadius:8 }}>
                    {fmResults.map((r, i) => (
                      <div key={r.id+String(i)} style={{ display:'flex', gap:10, alignItems:'center', padding:10, borderBottom:'1px solid rgba(255,255,255,0.06)' }}>
                        {r.thumb ? <img src={r.thumb} alt="thumb" style={{ width:120, height:68, objectFit:'cover', borderRadius:6 }} /> : <div style={{ width:120, height:68, background:'#0b0e10', borderRadius:6 }} />}
                        <div style={{ flex:1 }}>
                          <div style={{ fontWeight:700 }}>{r.title || r.id}</div>
                          <div style={{ opacity:0.7, fontSize:12 }}>{r.host}</div>
                        </div>
                        <button
                          style={btnPrimary}
                          onClick={async ()=>{
                            try {
                              const url = r.embedUrl || r.pageUrl || r.url || r.link || '';
                              if (!url) return;
                              const normalized = toEmbedAutoplay(url);
                              if (fmLangForEp != null) {
                                // add/update language entry on episode
                                const { idx, code } = fmLangForEp;
                                addOrUpdateLangToEp(idx, code, { videoUrl: normalized, name: LANG_MAP[code]?.name, flag: LANG_MAP[code]?.country });
                                showToast('Jazyk přidán', 'success');
                                setFmLangForEp(null);
                              } else if (fmForEpIndex != null) {
                                // Ensure immediate UI update: write to model synchronously so the readOnly input shows the URL
                                try {
                                  setModel(prev => {
                                    const eps = Array.isArray(prev.episodes) ? prev.episodes.map(e => ({ ...(e||{}) })) : [];
                                    const ep = eps[fmForEpIndex] || {};
                                    eps[fmForEpIndex] = { ...ep, videoUrl: normalized };
                                    return { ...prev, episodes: eps };
                                  });
                                } catch (_) {}
                                // Also run the side-effects (create/update play page)
                                try { await updEpWithSideEffects(fmForEpIndex, { videoUrl: normalized }); } catch (_) {}
                                showToast('Video vybráno', 'success');
                              }
                              setFmOpen(false);
                            } catch (e) {
                              showToast('Nelze nastavit video', 'error');
                            }
                          }}
                        >Vybrat</button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {fmTab==='folders' && (
                <div style={{ marginTop:10, display:'grid', gridTemplateColumns:'240px 1fr', gap:12 }}>
                  <div style={{ border:'1px solid rgba(255,255,255,0.06)', borderRadius:8, maxHeight:'60vh', overflowY:'auto' }}>
                    {fmFolders.length === 0 && <div style={{ padding:8, opacity:0.7 }}>Žádné složky</div>}
                    <div style={{ padding:8, display:'flex', alignItems:'center', gap:8 }}>
                      <div style={{ color:'#ddd', fontSize:13 }}>Seřadit:</div>
                      <select
                        ref={fmFoldersSortRef}
                        value={fmFoldersSort}
                        onClick={() => { openNativeSelect(fmFoldersSortRef); try { fmFolderSearchRef.current && fmFolderSearchRef.current.focus(); fmFolderSearchRef.current && fmFolderSearchRef.current.select && fmFolderSearchRef.current.select(); } catch (e) {} }}
                        onChange={e=>{ setFmFoldersSort(e.target.value); try { fmFolderSearchRef.current && fmFolderSearchRef.current.focus(); fmFolderSearchRef.current && fmFolderSearchRef.current.select && fmFolderSearchRef.current.select(); } catch (e) {} }}
                        style={{ padding:6, borderRadius:6, background:'#071014', color:'#fff', border:'1px solid rgba(255,255,255,0.04)' }}>
                        <option value="name:asc">Název ↑</option>
                        <option value="name:desc">Název ↓</option>
                      </select>
                    </div>
                    {(fmFolders||[]).slice().sort((a,b)=>{
                      const an = (a.name||'').toLowerCase(); const bn = (b.name||'').toLowerCase();
                      return fmFoldersSort === 'name:asc' ? an.localeCompare(bn) : bn.localeCompare(an);
                    }).map(f => (
                      <div key={f.id} style={{ padding:'8px 10px', cursor:'pointer', background: fmFolderId===f.id ? '#223' : 'transparent' }}
                           onClick={async ()=>{
                             setFmFolderId(f.id);
                             setFmError(''); setFmFolderFiles([]);
                             try {
                               setFmBusy(true);
                               const r = await fetch(`${apiBase}/filemoon/files?folderId=${encodeURIComponent(f.id)}`);
                               if (!r.ok) throw new Error('bad');
                               const j = await r.json();
                               setFmFolderFiles(Array.isArray(j) ? j : []);
                             } catch (_) { setFmError('Nelze načíst soubory složky.'); }
                             finally { setFmBusy(false); }
                           }}
                      >{f.name || f.id}</div>
                    ))}
                  </div>
                  <div>
                    <div style={{ display:'flex', gap:8, marginBottom:8, alignItems:'center' }}>
                      <input
                        placeholder={fmFolderId ? 'Hledat v této složce…' : 'Vyber nejprve složku'}
                        disabled={!fmFolderId}
                        ref={fmFolderSearchRef}
                        style={{ ...input, flex:1 }}
                        autoFocus={fmTab==='folders'}
                        onMouseDown={e=>{ e.stopPropagation(); }}
                        onClick={e=>{ e.stopPropagation(); e.currentTarget.focus(); }}
                        onKeyDown={async (e)=>{
                          if (e.key==='Enter' && fmFolderId) {
                            const q = e.currentTarget.value.trim();
                            setFmBusy(true); setFmError('');
                            try {
                              const url = `${apiBase}/filemoon/files?folderId=${encodeURIComponent(fmFolderId)}${q?`&search=${encodeURIComponent(q)}`:''}`;
                              const r = await fetch(url);
                              if (!r.ok) throw new Error('bad');
                              const j = await r.json();
                              setFmFolderFiles(Array.isArray(j) ? j : []);
                            } catch (_) { setFmError('Hledání ve složce selhalo.'); }
                            finally { setFmBusy(false); }
                          }
                        }}
                      />
                      <button
                        style={btn}
                        disabled={!fmFolderId}
                        onClick={async (e)=>{
                          const wrapper = e.currentTarget.parentElement;
                          const inputEl = wrapper?.querySelector('input');
                          const q = (inputEl?.value || '').trim();
                          setFmBusy(true); setFmError('');
                          try {
                            const url = `${apiBase}/filemoon/files?folderId=${encodeURIComponent(fmFolderId)}${q?`&search=${encodeURIComponent(q)}`:''}`;
                            const r = await fetch(url);
                            if (!r.ok) throw new Error('bad');
                            const j = await r.json();
                            setFmFolderFiles(Array.isArray(j) ? j : []);
                          } catch (_) { setFmError('Hledání ve složce selhalo.'); }
                          finally { setFmBusy(false); }
                        }}
                      >Hledat</button>
                      <div style={{ marginLeft:6, display:'flex', alignItems:'center', gap:8 }}>
                        <div style={{ color:'#ddd', fontSize:13 }}>Seřadit:</div>
                        <select
                          ref={fmFilesSortRef}
                          value={fmFilesSort}
                          onClick={() => { openNativeSelect(fmFilesSortRef); try { fmFolderSearchRef.current && fmFolderSearchRef.current.focus(); fmFolderSearchRef.current && fmFolderSearchRef.current.select && fmFolderSearchRef.current.select(); } catch (e) {} }}
                          onChange={e=>{ setFmFilesSort(e.target.value); try { fmFolderSearchRef.current && fmFolderSearchRef.current.focus(); fmFolderSearchRef.current && fmFolderSearchRef.current.select && fmFolderSearchRef.current.select(); } catch (e) {} }}
                          style={{ padding:6, borderRadius:6, background:'#071014', color:'#fff', border:'1px solid rgba(255,255,255,0.04)' }}>
                          <option value="name:asc">Název ↑</option>
                          <option value="name:desc">Název ↓</option>
                        </select>
                      </div>
                    </div>
                    <div style={{ border:'1px solid rgba(255,255,255,0.06)', borderRadius:8, maxHeight:'60vh', overflowY:'auto' }}>
                    {fmFolderFiles.length === 0 && <div style={{ padding:8, opacity:0.7 }}>Žádné soubory</div>}
                    {(fmFolderFiles||[]).slice().sort((a,b)=>{
                      const an = (a.title||a.id||'').toLowerCase(); const bn = (b.title||b.id||'').toLowerCase();
                      return fmFilesSort === 'name:asc' ? an.localeCompare(bn) : bn.localeCompare(an);
                    }).map((r, i) => (
                      <div key={r.id+String(i)} style={{ display:'flex', gap:10, alignItems:'center', padding:10, borderBottom:'1px solid rgba(255,255,255,0.06)' }}>
                        {r.thumb ? <img src={r.thumb} alt="thumb" style={{ width:120, height:68, objectFit:'cover', borderRadius:6 }} /> : <div style={{ width:120, height:68, background:'#0b0e10', borderRadius:6 }} />}
                        <div style={{ flex:1 }}>
                          <div style={{ fontWeight:700 }}>{r.title || r.id}</div>
                          <div style={{ opacity:0.7, fontSize:12 }}>{r.host}</div>
                        </div>
                        <button
                          style={btnPrimary}
                          onClick={async ()=>{
                            try {
                              const url = r.embedUrl || r.pageUrl || r.url || r.link || '';
                              if (!url) return;
                              const normalized = toEmbedAutoplay(url);
                              if (fmLangForEp != null) {
                                const { idx, code } = fmLangForEp;
                                addOrUpdateLangToEp(idx, code, { videoUrl: normalized, name: LANG_MAP[code]?.name, flag: LANG_MAP[code]?.country });
                                showToast('Jazyk přidán', 'success');
                                setFmLangForEp(null);
                              } else if (fmForEpIndex != null) {
                                // Ensure immediate UI update
                                try {
                                  setModel(prev => {
                                    const eps = Array.isArray(prev.episodes) ? prev.episodes.map(e => ({ ...(e||{}) })) : [];
                                    const ep = eps[fmForEpIndex] || {};
                                    eps[fmForEpIndex] = { ...ep, videoUrl: normalized };
                                    return { ...prev, episodes: eps };
                                  });
                                } catch (_) {}
                                try { await updEpWithSideEffects(fmForEpIndex, { videoUrl: normalized }); } catch (_) {}
                                showToast('Video vybráno', 'success');
                              }
                              setFmOpen(false);
                            } catch (e) {
                              showToast('Nelze nastavit video', 'error');
                            }
                          }}
                        >Vybrat</button>
                      </div>
                    ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Full collection modal with search and scrollable list */}
      {collectionOpen && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:100000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={()=>setCollectionOpen(false)}>
          <div style={{ width:'860px', maxWidth:'96%', maxHeight:'86vh', background:'#10161e', color:'#fff', borderRadius:12, border:'1px solid rgba(255,255,255,0.06)', boxShadow:'0 20px 60px rgba(0,0,0,0.6)', display:'flex', flexDirection:'column' }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 14px', borderBottom:'1px solid rgba(255,255,255,0.06)' }}>
              <div style={{ fontWeight:800 }}>Všechny popupy</div>
              <button onClick={()=>setCollectionOpen(false)} style={{ ...btn, background:'transparent' }}>Zavřít</button>
            </div>
            <div style={{ padding:14 }} onClick={()=>collectionInputRef.current?.focus()}>
              <label style={{...label, marginBottom:4}}>Vyhledat</label>
              <input
                ref={collectionInputRef}
                style={input}
                placeholder="Hledat podle názvu"
                value={collectionQuery}
                onChange={(e)=>setCollectionQuery(e.target.value)}
              />
            </div>
            <div style={{ padding:'0 14px 14px', overflowY:'auto' }}>
              {(() => {
                const q = (collectionQuery||'').trim().toLowerCase();
                const filtered = q ? (list||[]).filter(it => (it.title||'').toLowerCase().includes(q)) : (list||[]);
                if (!filtered.length) return <div style={{ padding:10, color:'#bbb' }}>Žádné</div>;
                return filtered.map((it) => (
                  <div key={it.id} style={{ padding:'10px 0', borderBottom:'1px solid #1f2830' }}>
                    <div style={{ display:'flex', justifyContent:'space-between', gap:8 }}>
                      <div>
                        <div style={{ fontWeight:600 }}>{it.title}</div>
                        <div style={{ fontSize:12, opacity:0.8 }}>{it.year}{it.contentType==='film' ? '' : ` • ${it.seasons} řad`}</div>
                      </div>
                      <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'nowrap' }}>
                        <button style={btn} onClick={()=>{ setModel(it); setEditingId(it.id); const p=new URLSearchParams(window.location.search||''); p.set('preview', String(it.id)); const newUrl=`${window.location.pathname}?${p.toString()}`; window.history.pushState({}, '', newUrl); window.dispatchEvent(new CustomEvent('preview:open', { detail: { id: String(it.id) } })); setPreviewOpenState(true); setCollectionOpen(false); }}>Otevřít</button>
                        <button style={btnPrimary} onClick={()=>{ edit(it); setCollectionOpen(false); }}>Upravit</button>
                        <button style={btn} onClick={()=>copyLink(it.id)} title="Zkopírovat odkaz">
                          {copiedKey === String(it.id) ? 'Zkopírováno' : 'Odkaz'}
                        </button>
                        <button style={{ ...btnWarn }} onClick={()=>remove(it.id)}>Smazat</button>
                      </div>
                    </div>
                  </div>
                ));
              })()}
            </div>
          </div>
        </div>
      )}

      {/* TMDb Import Modal */}
      {tmdbOpen && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:100000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={()=>setTmdbOpen(false)}>
          <div style={{ width:'760px', maxWidth:'96%', maxHeight:'85vh', display:'flex', flexDirection:'column', background:'#10161e', color:'#fff', borderRadius:12, border:'1px solid rgba(255,255,255,0.06)', boxShadow:'0 20px 60px rgba(0,0,0,0.6)' }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 14px', borderBottom:'1px solid rgba(255,255,255,0.06)' }}>
              <div style={{ fontWeight:800 }}>Import z TMDb</div>
              <button onClick={()=>setTmdbOpen(false)} style={{ ...btn, background:'transparent' }}>Zavřít</button>
            </div>
            <div style={{ padding:14, overflow:'auto' }}>
              <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                <div>
                  <label style={{ marginRight:8 }} onMouseDown={(e)=>e.stopPropagation()} onClick={(e)=>{ e.stopPropagation(); e.currentTarget.querySelector('input')?.focus(); }}>
                    <input type="radio" name="tmdbMode" checked={tmdbMode==='tv'} onChange={()=>{ setTmdbMode('tv'); setTmdbResults([]); }} onMouseDown={(e)=>e.stopPropagation()} /> Seriál
                  </label>
                  <label onMouseDown={(e)=>e.stopPropagation()} onClick={(e)=>{ e.stopPropagation(); e.currentTarget.querySelector('input')?.focus(); }}>
                    <input type="radio" name="tmdbMode" checked={tmdbMode==='movie'} onChange={()=>{ setTmdbMode('movie'); setTmdbResults([]); }} onMouseDown={(e)=>e.stopPropagation()} /> Film
                  </label>
                </div>
                <input
                  value={tmdbQuery}
                  onChange={(e)=>setTmdbQuery(e.target.value)}
                  placeholder="Zadej název seriálu/filmu (např. Miraculous)"
                  style={{ ...input, flex:1 }}
                  onMouseDown={(e)=>{ e.stopPropagation(); }}
                  onClick={(e)=>{ e.stopPropagation(); e.currentTarget.focus(); }}
                  onKeyDown={async (e)=>{
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      setTmdbError(''); setTmdbResults([]);
                      if (!tmdbQuery.trim()) return;
                      try {
                        setTmdbBusy(true);
                        const res = tmdbMode==='tv'
                          ? await tmdb.searchTV(tmdbQuery.trim(), { language: 'cs-CZ' })
                          : await tmdb.searchMovie(tmdbQuery.trim(), { language: 'cs-CZ' });
                        setTmdbResults(res || []);
                      } catch (err) {
                        setTmdbError('Chyba vyhledávání TMDb. Zkontroluj API klíč a síť.');
                      } finally { setTmdbBusy(false); }
                    }
                  }}
                />
                <button
                  style={btnPrimary}
                  onClick={async ()=>{
                    setTmdbError(''); setTmdbResults([]);
                    if (!tmdbQuery.trim()) return;
                    try {
                      setTmdbBusy(true);
                      const res = tmdbMode==='tv'
                        ? await tmdb.searchTV(tmdbQuery.trim(), { language: 'cs-CZ' })
                        : await tmdb.searchMovie(tmdbQuery.trim(), { language: 'cs-CZ' });
                      setTmdbResults(res || []);
                    } catch (e) {
                      setTmdbError('Chyba vyhledávání TMDb. Zkontroluj API klíč a síť.');
                    } finally { setTmdbBusy(false); }
                  }}
                >Hledat</button>
              </div>
              {tmdbError && <div style={{ color:'#f88', marginTop:8 }}>{tmdbError}</div>}
              {tmdbBusy && <div style={{ marginTop:8 }}>Načítám…</div>}
              {!!tmdbResults?.length && (
                <div style={{ marginTop:12 }}>
            <div style={{ fontWeight:700, marginBottom:8 }}>Výsledky</div>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(220px, 1fr))', gap:10 }}>
                    {tmdbResults.map((r)=>{
                      const poster = tmdb.buildImageUrl(r.poster_path, 'w300');
                      return (
                        <div key={r.id} style={{ border:'1px solid rgba(255,255,255,0.06)', borderRadius:8, overflow:'hidden', background:'#0b0e10' }}>
                          <div style={{ display:'flex', gap:8 }}>
                            <img src={poster} alt="poster" style={{ width:84, height:124, objectFit:'cover', borderRadius:6 }} />
                            <div style={{ padding:8, flex:1 }}>
                              <div style={{ fontWeight:700 }}>{tmdbMode==='tv' ? r.name : r.title}</div>
                              <div style={{ opacity:0.8, fontSize:12 }}>{(tmdbMode==='tv' ? (r.first_air_date || r.release_date || '') : (r.release_date || r.first_air_date || '')).slice(0,4)}</div>
                              <div style={{ marginTop:8 }}>
                                <button
                                  style={btn}
                                  onClick={async ()=>{
                                    try {
                                      setTmdbBusy(true);
                                      if (tmdbMode==='tv') {
                                        const tv = await tmdb.getTV(r.id, { language: 'cs-CZ' }).catch(()=>null);
                                        const seasonsCount = (tv && Array.isArray(tv.seasons)) ? tv.seasons.filter(s=>s.season_number>0).length : (r.number_of_seasons || 1);
                                        const hero = tmdb.buildImageUrl(tv?.backdrop_path || r.backdrop_path, 'w780');
                                        const posterFull = tmdb.buildImageUrl(tv?.poster_path || r.poster_path, 'w500');
                                        const targetSeasons = seasonsCount || 1;
                                        const genres = Array.isArray(tv?.genres) ? tv.genres.map(g=>g && g.name).filter(Boolean).slice(0,3) : [];
                                        const allEpisodes = [];
                                        for (let s = 1; s <= targetSeasons; s++) {
                                          try {
                                            const season = await tmdb.getSeasonWithFallback(r.id, s);
                                            for (const ep of (season.episodes || [])) {
                                              // Prefer official TMDb Czech translation of episode name/overview if available.
                                              let title = ep.name || '';
                                              let desc = ep.overview || '';
                                              // If CZ missing flags are set, we likely have EN values in name/overview. Replace them with CS.
                                              if (ep.czNameMissing || ep.czOverviewMissing) {
                                                const tr = await tmdb.getEpisodeTranslationCS(r.id, s, ep.episode_number).catch(()=>null);
                                                if (ep.czNameMissing) {
                                                  if (tr && tr.name) {
                                                    title = tr.name;
                                                  } else if (ep.en_name) {
                                                    title = await translateText(ep.en_name, { source: 'en', target: 'cs' });
                                                  }
                                                }
                                                if (ep.czOverviewMissing) {
                                                  if (tr && tr.overview) {
                                                    desc = tr.overview;
                                                  } else if (ep.en_overview) {
                                                    desc = await translateText(ep.en_overview, { source: 'en', target: 'cs' });
                                                  }
                                                }
                                              }
                                              // If no title at all, fallback
                                              if (!title) title = `Epizoda ${ep.episode_number}`;
                                              allEpisodes.push({
                                                season: s,
                                                index: ep.episode_number,
                                                title,
                                                thumb: tmdb.buildImageUrl(ep.still_path, 'w500'),
                                                videoUrl: '',
                                                desc
                                              });
                                            }
                                          } catch (_) {}
                                        }
                                        setModel(m => ({
                                          ...m,
                                          tmdbType: 'tv',
                                          tmdbId: r.id,
                                          contentType: 'serial',
                                          lockContentType: true,
                                          title: tv?.name || r.name || m.title,
                                          year: String((tv?.first_air_date || r.first_air_date || tv?.release_date || r.release_date || '')).slice(0,4) || m.year,
                                          seasons: targetSeasons,
                                          genres: genres.length ? genres : (m.genres||[]),
                                          heroImage: hero || m.heroImage,
                                          seriesLogo: m.seriesLogo,
                                          // Prefer landscape backdrop for tile (dlaždice) and poster for search
                                          listThumb: hero || m.listThumb,
                                          searchPoster: posterFull || m.searchPoster,
                                          episodes: allEpisodes
                                        }));
                                      } else {
                                        const mv = await tmdb.getMovieWithFallback(r.id);
                                        const backdrop = tmdb.buildImageUrl(mv.backdrop_path || r.backdrop_path, 'w780');
                                        const posterFull = tmdb.buildImageUrl(mv.poster_path || r.poster_path, 'w500');
                                        let title = mv.title || r.title || 'Film';
                                        let overview = mv.overview || '';
                                        if (mv.czOverviewMissing && mv.enOverview) overview = await translateText(mv.enOverview, { source: 'en', target: 'cs' });
                                        const runtimeMins = Number(mv.runtime)||0;
                                        const genres = Array.isArray(mv.genres) ? mv.genres.map(g=>g && g.name).filter(Boolean).slice(0,3) : [];
                                        setModel(m => ({
                                          ...m,
                                          tmdbType: 'movie',
                                          tmdbId: r.id,
                                          contentType: 'film',
                                          lockContentType: true,
                                          title,
                                          overview: overview || m.overview || '',
                                          runtimeMins: runtimeMins || m.runtimeMins || 0,
                                          genres: genres.length ? genres : (m.genres||[]),
                                          year: String((mv.release_date || r.release_date || mv.first_air_date || r.first_air_date || '')).slice(0,4) || m.year,
                                          seasons: 1,
                                          heroImage: backdrop || m.heroImage,
                                          seriesLogo: m.seriesLogo,
                                          // Prefer landscape backdrop for tile (dlaždice) and poster for search
                                          listThumb: backdrop || m.listThumb,
                                          searchPoster: posterFull || m.searchPoster,
                                          episodes: [
                                            {
                                              season: 1,
                                              index: 1,
                                              title: title || 'Film',
                                              // Use backdrop or tile as episode thumb for film preview lists
                                              thumb: backdrop || m.listThumb || m.searchPoster || m.heroImage || '',
                                              videoUrl: '',
                                              desc: overview || ''
                                            }
                                          ]
                                        }));
                                      }
                                      showToast('Načteno z TMDb', 'success');
                                      setTmdbOpen(false);
                                    } catch (e) {
                                      console.error('TMDb import error', e);
                                      showToast('Import z TMDb selhal', 'error');
                                    } finally {
                                      setTmdbBusy(false);
                                    }
                                  }}
                                >Importovat</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Floating primary add/save button for clarity */}
      <button
        onClick={save}
        style={{
          position:'fixed', right:24, bottom:24, zIndex:100000,
          ...btnPrimary,
          boxShadow:'0 6px 16px rgba(0,0,0,0.4)',
          padding:'12px 18px',
          fontWeight:600
        }}
        title={editingId ? 'Uložit změny' : 'Přidat popup'}
      >{editingId ? 'Uložit změny' : 'Přidat popup'}</button>
    </div>
  );
}

// Simple in-file toast system for nice messages
let toastQueue = [];
let toastListeners = [];
function showToast(message, type = 'success') {
  const id = Date.now() + Math.random();
  const item = { id, message, type };
  toastQueue.push(item);
  toastListeners.forEach(fn => fn([...toastQueue]));
  setTimeout(() => {
    toastQueue = toastQueue.filter(t => t.id !== id);
    toastListeners.forEach(fn => fn([...toastQueue]));
  }, 2200);
}

function ToastHost() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    function onChange(list) { setItems(list); }
    toastListeners.push(onChange);
    return () => { toastListeners = toastListeners.filter(fn => fn !== onChange); };
  }, []);
  if (!items.length) return null;
  return (
    <div style={{ position:'fixed', right:16, top:16, zIndex: 1000000, display:'flex', flexDirection:'column', gap:8 }}>
      {items.map(it => (
        <div key={it.id} style={{
          minWidth: 220,
          maxWidth: 360,
          background: it.type === 'error'
            ? 'linear-gradient(180deg, #4b1f1f, #b83a3a)'
            : it.type === 'warning'
              ? 'linear-gradient(180deg, #584c1a, #d5a419)'
              : 'linear-gradient(180deg, #1f3b2a, #2d8a34)',
          border: '1px solid rgba(255,255,255,0.12)',
          color: '#fff',
          padding: '10px 14px',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,0.45)',
          fontWeight: 700,
          letterSpacing: 0.2,
        }}>
          {it.message}
        </div>
      ))}
    </div>
  );
}

const btn = { background:'#234', color:'#cde', border:'none', padding:'8px 12px', borderRadius:6, cursor:'pointer' };
const btnPrimary = { ...btn, background:'#2d8a34', color:'#fff' };
const btnWarn = { ...btn, background:'#933', color:'#fff' };
const label = { display:'block', color:'#cdd', fontSize:13, marginBottom:6 };
const input = { width:'100%', padding:'8px 10px', borderRadius:6, border:'1px solid #333', background:'#0f1418', color:'#fff' };
const row = { marginBottom:10 };
const pillPrimary = { background:'#fff', color:'#000', border:'none', padding:'10px 16px', borderRadius:999, fontWeight:700, cursor:'pointer' };
const pillSecondary = { background:'transparent', color:'#fff', border:'1px solid rgba(255,255,255,0.4)', padding:'9px 14px', borderRadius:999, fontWeight:600, cursor:'pointer' };
const pillSecondaryOn = { ...pillSecondary, background:'#2d8a34', border:'none' };
const panel = { background:'#0b0e10', border:'1px solid #1f2830', borderRadius:10, padding:12, marginBottom:12 };
const sectionTitle = { fontWeight:800, letterSpacing:0.2, marginBottom:8, fontSize:14, color:'#dbe' };
const chipBtn = { ...btn, borderRadius: 999, padding:'6px 10px' };